
// import React, { useState, useEffect } from 'react';
// import {
//   Box, Typography, Paper, Grid, Card, CardContent, Button, Chip,
//   Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
//   IconButton, MenuItem, FormControl, InputLabel, Select, Dialog,
//   DialogTitle, DialogContent, DialogActions, CircularProgress, Stack,
//   Tooltip, Radio, RadioGroup, FormControlLabel, ThemeProvider,
//   createTheme, CssBaseline, Alert, AlertTitle,
// } from '@mui/material';
// import {
//   PictureAsPdf, FileCopy, Description, Business, Shield,
//   Warning as WarningIcon, Download,
// } from '@mui/icons-material';
// import api from '../../services/api';
// import { useSnackbar } from 'notistack';
// import jsPDF from 'jspdf';
// import autoTable from 'jspdf-autotable';

// // ─── Theme ────────────────────────────────────────────────────────────────────
// const theme = createTheme({
//   palette: {
//     mode: 'light',
//     primary: { main: '#0F172A', light: '#334155', dark: '#020617' },
//     secondary: { main: '#2563EB', light: '#DBEAFE', dark: '#1D4ED8' },
//     background: { default: '#F1F5F9', paper: '#FFFFFF' },
//     text: { primary: '#0F172A', secondary: '#475569', disabled: '#94A3B8' },
//     divider: '#E2E8F0',
//   },
//   typography: {
//     fontFamily: '"Inter", "SF Pro Display", "Segoe UI", system-ui, sans-serif',
//     h4: { fontWeight: 700, letterSpacing: '-0.02em', color: '#0F172A' },
//     h5: { fontWeight: 600, letterSpacing: '-0.02em', color: '#0F172A' },
//     h6: { fontWeight: 600, color: '#0F172A' },
//     subtitle1: { fontWeight: 600 },
//     subtitle2: { fontWeight: 600 },
//     button: { textTransform: 'none', fontWeight: 600, letterSpacing: '0.01em' },
//   },
//   shape: { borderRadius: 8 },
//   components: {
//     MuiCard: {
//       styleOverrides: {
//         root: {
//           boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.05), 0 2px 4px -2px rgb(0 0 0 / 0.05)',
//           border: '1px solid #E2E8F0',
//           transition: 'all 0.2s ease-in-out',
//         },
//       },
//     },
//     MuiPaper: { styleOverrides: { root: { backgroundImage: 'none' } } },
//     MuiButton: {
//       styleOverrides: {
//         root: { boxShadow: 'none', '&:hover': { boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)' } },
//       },
//     },
//     MuiTableCell: {
//       styleOverrides: {
//         head: { fontWeight: 600, color: '#475569', backgroundColor: '#F8FAFC', borderBottom: '1px solid #E2E8F0' },
//         root: { padding: '16px' },
//       },
//     },
//   },
// });

// // ─── Types ─────────────────────────────────────────────────────────────────────
// interface Vendor {
//   id: string; name: string; domain: string; score: number;
//   riskLevel: string; lastScan: string; created_at?: string;
//   lifecycle?: string; status?: string;
// }
// interface Indicator {
//   indicator_name: string; category: string; severity: string;
//   score_impact: number; description: string; recommendation: string;
//   evidence: any; is_applicable?: boolean; endpoint_url?: string;
// }
// interface Scan {
//   id: string; domain: string; overall_score: number; risk_level: string;
//   completed_at: string; company_name?: string; indicators?: Indicator[];
//   endpoints_json?: any;  // Added for affected endpoints
// }

// // ─── PDF Color Palette ────────────────────────────────────────────────────────
// type RGB = [number, number, number];
// const C = {
//   navy:       [15, 23, 42]    as RGB,
//   navyMid:    [30, 41, 59]    as RGB,
//   navyLight:  [51, 65, 85]    as RGB,
//   accent:     [37, 99, 235]   as RGB,
//   accentMid:  [59, 130, 246]  as RGB,
//   accentPale: [219, 234, 254] as RGB,
//   slate:      [71, 85, 105]   as RGB,
//   muted:      [148, 163, 184] as RGB,
//   border:     [226, 232, 240] as RGB,
//   bgLight:    [248, 250, 252] as RGB,
//   bgRow:      [241, 245, 249] as RGB,
//   white:      [255, 255, 255] as RGB,
//   critRed:    [185, 28, 28]   as RGB,  critRedBg:  [254, 226, 226] as RGB,
//   highOr:     [194, 65, 12]   as RGB,  highOrBg:   [255, 237, 213] as RGB,
//   medYel:     [161, 98, 7]    as RGB,  medYelBg:   [254, 249, 195] as RGB,
//   lowGrn:     [21, 128, 61]   as RGB,  lowGrnBg:   [220, 252, 231] as RGB,
//   infoBlue:   [29, 78, 216]   as RGB,  infoBlueBg: [239, 246, 255] as RGB,
//   charcoal:   [30, 41, 59]    as RGB,
// };

// // ─── Helpers ──────────────────────────────────────────────────────────────────
// const getRiskLevelText = (level: string) => {
//   switch (level?.toLowerCase()) {
//     case 'low': return 'Low Risk'; case 'medium': return 'Medium Risk';
//     case 'high': return 'High Risk'; case 'critical': return 'Critical Risk';
//     default: return 'Not Assessed';
//   }
// };
// const getScoreGrade = (score: number) => {
//   if (score >= 90) return { letter: 'A', color: [16, 185, 129] as RGB, bg: [209, 250, 229] as RGB };
//   if (score >= 80) return { letter: 'B', color: [59, 130, 246] as RGB, bg: [219, 234, 254] as RGB };
//   if (score >= 70) return { letter: 'C', color: [245, 158, 11] as RGB, bg: [254, 243, 199] as RGB };
//   if (score >= 60) return { letter: 'D', color: [249, 115, 22] as RGB, bg: [255, 237, 213] as RGB };
//   return { letter: 'F', color: [239, 68, 68] as RGB, bg: [254, 226, 226] as RGB };
// };
// const getSevColors = (sev: string): { fg: RGB; bg: RGB } => {
//   switch (sev?.toLowerCase()) {
//     case 'critical': return { fg: C.critRed, bg: C.critRedBg };
//     case 'high':     return { fg: C.highOr,  bg: C.highOrBg };
//     case 'medium':   return { fg: C.medYel,  bg: C.medYelBg };
//     case 'low':      return { fg: C.lowGrn,  bg: C.lowGrnBg };
//     default:         return { fg: C.slate,   bg: C.bgLight };
//   }
// };
// const formatEvidence = (evidence: any): string => {
//   if (!evidence) return '—';
//   if (typeof evidence === 'string') return evidence;
//   const parts: string[] = [];
//   if (evidence.value)               parts.push(`Value: ${evidence.value}`);
//   if (evidence.rating)              parts.push(`Rating: ${evidence.rating}`);
//   if (evidence.risk_score !== undefined) parts.push(`Risk Score: ${evidence.risk_score}/100`);
//   if (evidence.open_ports?.length)  parts.push(`Open Ports: ${evidence.open_ports.join(', ')}`);
//   if (evidence.filtered_ports?.length) parts.push(`Filtered Ports: ${evidence.filtered_ports.join(', ')}`);
//   if (evidence.suspicious_domains?.length) parts.push(`Suspicious Domains: ${evidence.suspicious_domains.join(', ')}`);
//   if (evidence.blacklists?.length)  parts.push(`Blacklists: ${evidence.blacklists.join(', ')}`);
//   if (evidence.banner)              parts.push(`Banner: ${evidence.banner}`);
//   if (evidence.ip)                  parts.push(`IP: ${evidence.ip}`);
//   if (evidence.port)                parts.push(`Port: ${evidence.port}`);
//   if (evidence.version)             parts.push(`Version: ${evidence.version}`);
//   if (evidence.issuer)              parts.push(`Issuer: ${evidence.issuer}`);
//   if (evidence.expiry_date)         parts.push(`Expiry: ${evidence.expiry_date}`);
//   if (evidence.days_left !== undefined) parts.push(`Days Left: ${evidence.days_left}`);
//   if (evidence.is_applicable !== undefined) parts.push(`Applicable: ${evidence.is_applicable ? 'Yes' : 'No'}`);
//   if (evidence.environment)         parts.push(`Environment: ${evidence.environment}`);
//   return parts.length ? parts.join('\n') : JSON.stringify(evidence, null, 2).substring(0, 500);
// };

// // ── Get affected endpoints from scan endpoints_json ──────────────────────────
// const getAffectedEndpointsFromScan = (finding: Indicator, scan: Scan): string[] => {
//   // First check if the scan has endpoints_json data
//   if (!scan || !scan.endpoints_json) {
//     return [];
//   }

//   try {
//     const endpoints = typeof scan.endpoints_json === 'string' 
//       ? JSON.parse(scan.endpoints_json) 
//       : scan.endpoints_json;
    
//     if (!Array.isArray(endpoints)) return [];

//     const affectedUrls: string[] = [];
    
//     // Look for this indicator in each endpoint's findings
//     for (const ep of endpoints) {
//       const findings = ep.findings || [];
//       for (const f of findings) {
//         if (f.indicator_name === finding.indicator_name) {
//           const url = ep.url || ep.endpoint_url || '';
//           if (url && !affectedUrls.includes(url)) {
//             affectedUrls.push(url);
//           }
//           break;
//         }
//       }
//     }
    
//     return affectedUrls;
//   } catch (e) {
//     console.error('Error parsing endpoints_json:', e);
//     return [];
//   }
// };

// // ═══════════════════════════════════════════════════════════════════════════════
// // PDF GENERATION ENGINE - FULL ENTERPRISE REPORT (WITH UTF-8 SANITIZATION)
// // ═══════════════════════════════════════════════════════════════════════════════
// async function buildVendorPDF(vendor: Vendor, scan: Scan): Promise<jsPDF> {
//   // ── TEXT SANITIZATION HELPER (Fixes Mojibake / Encoding bugs) ─────────────
//   const sanitizeText = (str: any): string => {
//     if (str == null) return '';
//     return String(str)
//       .replace(/[\u2018\u2019]/g, "'")       // Smart single quotes
//       .replace(/[\u201C\u201D]/g, '"')       // Smart double quotes
//       .replace(/[\u2013\u2014]/g, '-')       // En and em dashes
//       .replace(/[\u2026]/g, '...')           // Ellipses
//       .replace(/[\u2022\u2023\u25E6\u2043\u2219]/g, '-') // Bullets to hyphens
//       .replace(/[^\x20-\x7E\r\n\t]/g, '');   // Strip all remaining non-ASCII
//   };

//   // ── Parse indicators ──────────────────────────────────────────────────────
//   let indicators: Indicator[] = scan.indicators || [];
//   if (typeof indicators === 'string') {
//     try { indicators = JSON.parse(indicators as any); } catch { indicators = []; }
//   }
//   if (!Array.isArray(indicators)) indicators = [];

//   // ── Meta ──────────────────────────────────────────────────────────────────
//   const reportId   = `AV-${new Date().getFullYear()}-${String(Math.floor(Math.random() * 90000) + 10000)}`;
//   const reportDate = new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
//   const grade      = getScoreGrade(vendor.score || 0);

//   const criticals = indicators.filter(i => i.severity?.toLowerCase() === 'critical');
//   const highs     = indicators.filter(i => i.severity?.toLowerCase() === 'high');
//   const mediums   = indicators.filter(i => i.severity?.toLowerCase() === 'medium');
//   const lows      = indicators.filter(i => i.severity?.toLowerCase() === 'low');
//   const findings  = indicators.filter(i => i.score_impact < 0).sort((a, b) => a.score_impact - b.score_impact);
//   const passing   = indicators.filter(i => i.score_impact >= 0);

//   // ── Page constants & Enterprise Theme ─────────────────────────────────────
//   const doc = new jsPDF({ unit: 'mm', format: 'a4', compress: true });
//   const PW = 210, PH = 297, ML = 18, MR = 18, CW = PW - ML - MR;
//   const HEADER_H = 18, FOOTER_H = 18;
//   const BODY_TOP = HEADER_H + 6;
//   const BODY_BTM = PH - FOOTER_H - 6;

//   const Theme = {
//     dark: [15, 23, 42] as RGB,          
//     textDark: [33, 37, 41] as RGB,      
//     textMuted: [108, 117, 125] as RGB,  
//     brand: [13, 110, 253] as RGB,       
//     border: [222, 226, 230] as RGB,     
//     bgLight: [248, 249, 250] as RGB,    
//     white: [255, 255, 255] as RGB,
//     crit: [220, 53, 69] as RGB,
//     high: [253, 126, 20] as RGB,
//     med:  [255, 193, 7] as RGB,
//     low:  [25, 135, 84] as RGB
//   };

//   const getSevColor = (sev: string): RGB => {
//     const s = sev.toLowerCase();
//     if (s === 'critical') return Theme.crit;
//     if (s === 'high') return Theme.high;
//     if (s === 'medium') return Theme.med;
//     return Theme.low;
//   };

//   // ── Low-level drawing helpers ─────────────────────────────────────────────
//   const setFill = (c: RGB) => doc.setFillColor(c[0], c[1], c[2]);
//   const setDraw = (c: RGB) => doc.setDrawColor(c[0], c[1], c[2]);
//   const setTxt  = (c: RGB) => doc.setTextColor(c[0], c[1], c[2]);
//   const setFont = (style: 'normal' | 'bold' | 'italic', size: number) => {
//     doc.setFont('helvetica', style); doc.setFontSize(size);
//   };

//   let currentPage = 1;
//   const addPage = () => { doc.addPage(); currentPage++; };

//   const safeY = (y: number, need = 30): number => {
//     if (y + need > BODY_BTM) { addPage(); return BODY_TOP; }
//     return y;
//   };

//   const sectionHeader = (title: string, subtitle: string, y: number): number => {
//     setFont('bold', 16); setTxt(Theme.dark);
//     doc.text(sanitizeText(title), ML, y);
//     if (subtitle) {
//       setFont('normal', 9); setTxt(Theme.textMuted);
//       doc.text(sanitizeText(subtitle), PW - MR, y, { align: 'right' });
//     }
//     y += 4;
//     setDraw(Theme.brand); doc.setLineWidth(0.8); doc.line(ML, y, ML + 30, y);
//     setDraw(Theme.border); doc.setLineWidth(0.2); doc.line(ML + 30, y, PW - MR, y);
//     return y + 12;
//   };

//   const subHeading = (title: string, y: number): number => {
//     setFont('bold', 11); setTxt(Theme.dark);
//     doc.text(sanitizeText(title), ML, y);
//     return y + 8;
//   };

//   const pill = (label: string, x: number, y: number, color: RGB) => {
//     setFont('bold', 7.5);
//     const cleanLabel = sanitizeText(label);
//     const w = Math.max(doc.getTextWidth(cleanLabel) + 8, 18);
//     setFill(Theme.white); setDraw(color); doc.setLineWidth(0.3);
//     doc.roundedRect(x - w, y - 4.5, w, 6.5, 1, 1, 'FD');
//     setTxt(color); doc.text(cleanLabel, x - w / 2, y, { align: 'center' });
//   };

//   const textBlock = (label: string, content: string, y: number): number => {
//     y = safeY(y, 20);
//     setFont('bold', 8.5); setTxt(Theme.dark);
//     doc.text(sanitizeText(label).toUpperCase(), ML, y);
//     y += 5;
//     setFont('normal', 9.5); setTxt(Theme.textDark);
    
//     // Sanitize before splitting to prevent encoding crashes
//     const cleanContent = sanitizeText(content || 'No details provided.');
//     const lines = doc.splitTextToSize(cleanContent, CW);
    
//     if (y + lines.length * 5 > BODY_BTM) { addPage(); y = BODY_TOP; }
//     doc.text(lines, ML, y);
//     return y + lines.length * 5 + 8;
//   };

//   const evidenceBlock = (content: string, y: number): number => {
//     y = safeY(y, 25);
    
//     // Sanitize evidence block data
//     const cleanContent = sanitizeText(content);
//     const lines = doc.splitTextToSize(cleanContent, CW - 10);
    
//     const boxH = lines.length * 4.2 + 8;
//     if (y + boxH > BODY_BTM) { addPage(); y = BODY_TOP; }
//     setFill(Theme.bgLight); setDraw(Theme.border); doc.setLineWidth(0.2);
//     doc.roundedRect(ML, y, CW, boxH, 1.5, 1.5, 'FD');
//     doc.setFont('courier', 'normal'); doc.setFontSize(8); setTxt(Theme.textDark);
//     doc.text(lines, ML + 5, y + 6);
//     doc.setFont('helvetica', 'normal');
//     return y + boxH + 8;
//   };

//   const affectedEndpointsBlock = (endpoints: string[], y: number): number => {
//     if (!endpoints || endpoints.length === 0) return y;
//     y = safeY(y, 25);
//     setFont('bold', 8.5); setTxt(Theme.dark);
//     doc.text('AFFECTED ENDPOINTS', ML, y);
//     y += 5;

//     const endpointsToShow = endpoints.slice(0, 15);
//     const endpointText = endpointsToShow.join('\n');
//     const extraCount = endpoints.length - 15;
//     const fullText = extraCount > 0 ? `${endpointText}\n... and ${extraCount} more` : endpointText;

//     const cleanText = sanitizeText(fullText);
//     const epLines = doc.splitTextToSize(cleanText, CW - 10);
//     const epBoxH = Math.max(epLines.length * 4.5 + 8, 16);

//     if (y + epBoxH > BODY_BTM) { addPage(); y = BODY_TOP; }

//     setFill(Theme.white); setDraw(Theme.border); doc.setLineWidth(0.2);
//     doc.roundedRect(ML, y, CW, epBoxH, 1.5, 1.5, 'FD');

//     doc.setFont('courier', 'normal'); doc.setFontSize(8); setTxt(Theme.textMuted);
//     doc.text(epLines, ML + 5, y + 6);
//     doc.setFont('helvetica', 'normal');
//     return y + epBoxH + 8;
//   };

//   // ═══════════════════════════════════════════════════════════════════════════
//   // PAGE 1 — COVER 
//   // ═══════════════════════════════════════════════════════════════════════════
//   setFill(Theme.bgLight); doc.rect(0, 0, PW, 15, 'F'); 

//   setFont('bold', 12); setTxt(Theme.brand);
//   doc.text('AstraVault', ML, 35);
//   setFont('normal', 9); setTxt(Theme.textMuted);
//   doc.text('Enterprise Cyber Risk Assessment', ML, 41);

//   setFill(Theme.white); setDraw(Theme.border); doc.setLineWidth(0.2);
//   doc.roundedRect(PW - MR - 28, 32, 28, 8, 1, 1, 'FD');
//   setFont('bold', 8); setTxt(Theme.textMuted);
//   doc.text('CONFIDENTIAL', PW - MR - 14, 37.5, { align: 'center' });

//   setFont('bold', 32); setTxt(Theme.dark);
//   const vNameLines = doc.splitTextToSize(sanitizeText(vendor.name), CW);
//   doc.text(vNameLines, ML, 90);
//   setFont('normal', 14); setTxt(Theme.textMuted);
//   doc.text(sanitizeText(vendor.domain), ML, 90 + vNameLines.length * 12 + 2);

//   const ringX = ML + 35, ringY = 160;
//   setDraw(grade.color as RGB); doc.setLineWidth(4);
//   doc.circle(ringX, ringY, 30, 'S'); 
//   setFont('bold', 42); setTxt(Theme.dark);
//   doc.text(grade.letter, ringX, ringY + 5, { align: 'center' });
//   setFont('normal', 12); setTxt(Theme.textMuted);
//   doc.text(`${vendor.score || 0} / 100`, ringX, ringY + 16, { align: 'center' });

//   setFont('bold', 10); setTxt(Theme.dark);
//   doc.text('Risk Classification:', ringX + 50, ringY - 10);
//   setFont('normal', 10); setTxt(Theme.textMuted);
//   doc.text(sanitizeText(getRiskLevelText(vendor.riskLevel)), ringX + 50, ringY - 4);

//   setFont('bold', 10); setTxt(Theme.dark);
//   doc.text('Findings Profile:', ringX + 50, ringY + 10);
//   setFont('normal', 10); setTxt(Theme.textMuted);
//   doc.text(`${findings.length} vulnerabilities detected`, ringX + 50, ringY + 16);

//   const metaY = 230;
//   setDraw(Theme.border); doc.setLineWidth(0.2);
//   doc.line(ML, metaY, PW - MR, metaY);
//   doc.line(ML, metaY + 25, PW - MR, metaY + 25);

//   setFont('bold', 8); setTxt(Theme.textMuted);
//   const col1 = ML, col2 = PW / 2;
//   doc.text('REPORT ID', col1, metaY + 8);
//   doc.text('DATE CONDUCTED', col2, metaY + 8);
//   doc.text('TOTAL CONTROLS', col1, metaY + 18);
//   doc.text('METHODOLOGY', col2, metaY + 18);

//   setFont('normal', 9); setTxt(Theme.dark);
//   doc.text(sanitizeText(reportId), col1 + 35, metaY + 8);
//   doc.text(sanitizeText(reportDate), col2 + 35, metaY + 8);
//   doc.text(`${indicators.length}`, col1 + 35, metaY + 18);
//   doc.text('External OSINT / Passive Recon', col2 + 35, metaY + 18);

//   setFont('normal', 8); setTxt(Theme.textMuted);
//   doc.text('Strictly Private and Confidential. Intended solely for authorized personnel.', PW / 2, PH - 20, { align: 'center' });

//   // ═══════════════════════════════════════════════════════════════════════════
//   // PAGE 2 — TABLE OF CONTENTS
//   // ═══════════════════════════════════════════════════════════════════════════
//   addPage();
//   let y = BODY_TOP;
//   y = sectionHeader('Table of Contents', '', y) + 5;

//   const toc = [
//     ['1', 'Executive Summary', '3'],
//     ['2', 'Risk Score & Grade Analysis', '3'],
//     ['3', 'Findings Overview by Severity', '4'],
//     ['4', 'Critical Severity Findings', criticals.length > 0 ? '5' : '—'],
//     ['5', 'High Severity Findings', highs.length > 0 ? '6+' : '—'],
//     ['6', 'Medium Severity Findings', mediums.length > 0 ? '7+' : '—'],
//     ['7', 'Low Severity Findings', lows.length > 0 ? '8+' : '—'],
//     ['8', 'Complete Findings Summary Table', '9+'],
//     ['9', 'Passing Controls', '10+'],
//     ['10', 'Applicability Analysis', '11+'],
//     ['11', 'Remediation Roadmap', '12+'],
//     ['12', 'Disclaimer & Certification', 'Last'],
//   ];

//   toc.forEach(([num, title, page], idx) => {
//     if (idx % 2 === 0) { setFill(Theme.bgLight); doc.rect(ML, y - 4, CW, 9, 'F'); }
//     setFont('bold', 9.5); setTxt(Theme.brand);
//     doc.text(num + '.', ML + 3, y + 1);
//     setFont('normal', 9.5); setTxt(Theme.textDark);
//     doc.text(title, ML + 14, y + 1);
//     setFont('bold', 9.5); setTxt(Theme.textMuted);
//     doc.text(`Page ${page}`, PW - MR - 3, y + 1, { align: 'right' });
    
//     setDraw(Theme.border); doc.setLineWidth(0.2);
//     const dotStart = ML + 16 + doc.getTextWidth(title);
//     for (let dx = dotStart; dx < PW - MR - 20; dx += 3) doc.circle(dx, y - 0.5, 0.25, 'F');
//     y += 9;
//   });

//   // ═══════════════════════════════════════════════════════════════════════════
//   // PAGE 3 — EXECUTIVE SUMMARY
//   // ═══════════════════════════════════════════════════════════════════════════
//   addPage();
//   y = BODY_TOP;
//   y = sectionHeader('Executive Summary', `Report ID: ${reportId}`, y);

//   setFont('normal', 9.5); setTxt(Theme.textDark);
//   const narrative = `This Third-Party Risk Assessment evaluates the external security posture of ${vendor.name} (${vendor.domain}), conducted on ${reportDate} using non-intrusive, passive OSINT-based reconnaissance. The assessment reviewed ${indicators.length} discrete security controls spanning network infrastructure, web application security, TLS/PKI, DNS integrity, cloud exposure, and supply-chain risk.`;
//   const narr2 = `The vendor achieved an overall security score of ${vendor.score ?? 'N/A'}/100 (Grade ${grade.letter}), with a risk classification of "${getRiskLevelText(vendor.riskLevel)}". A total of ${findings.length} findings were identified, including ${criticals.length} Critical, ${highs.length} High, ${mediums.length} Medium, and ${lows.length} Low severity issues. ${passing.length} controls passed assessment with no issues detected.`;
  
//   let nLines = doc.splitTextToSize(sanitizeText(narrative), CW);
//   doc.text(nLines, ML, y); y += nLines.length * 5.5 + 4;
//   nLines = doc.splitTextToSize(sanitizeText(narr2), CW);
//   doc.text(nLines, ML, y); y += nLines.length * 5.5 + 12;

//   y = subHeading('Risk Score & Grade Analysis', y);

//   const boxW = (CW - 9) / 4;
//   const boxes = [
//     { label: 'Security Score', val: `${vendor.score || 0}`, sub: '/ 100', fg: Theme.dark },
//     { label: 'Risk Grade', val: grade.letter, sub: 'Letter Grade', fg: grade.color },
//     { label: 'Risk Level', val: getRiskLevelText(vendor.riskLevel).replace(' Risk', ''), sub: 'Classification', fg: Theme.dark },
//     { label: 'Total Findings', val: `${findings.length}`, sub: 'Identified', fg: findings.length > 0 ? Theme.crit : Theme.low },
//   ];
  
//   boxes.forEach((b, i) => {
//     const bx = ML + i * (boxW + 3);
//     setFill(Theme.white); setDraw(Theme.border); doc.setLineWidth(0.3);
//     doc.roundedRect(bx, y, boxW, 28, 1.5, 1.5, 'FD');
//     setFont('bold', 18); setTxt(b.fg as RGB);
//     doc.text(sanitizeText(b.val), bx + boxW / 2, y + 12, { align: 'center' });
//     setFont('normal', 7.5); setTxt(Theme.textMuted);
//     doc.text(sanitizeText(b.label), bx + boxW / 2, y + 19, { align: 'center' });
//     doc.text(sanitizeText(b.sub), bx + boxW / 2, y + 24, { align: 'center' });
//   });
//   y += 36;

//   const interp = vendor.score >= 90 ? 'Excellent security posture. Vendor demonstrates strong controls across all evaluated domains with minimal exposure.' : vendor.score >= 75 ? 'Good security posture with some areas for improvement. Findings should be prioritized and tracked to closure.' : vendor.score >= 60 ? 'Moderate risk. Several meaningful security gaps exist. Immediate remediation of high and critical findings is recommended.' : 'Poor security posture. Significant vulnerabilities detected. Immediate vendor engagement and remediation plan required.';

//   setFill(Theme.bgLight); setDraw(Theme.border); doc.setLineWidth(0.2);
//   doc.roundedRect(ML, y, CW, 16, 1.5, 1.5, 'FD');
//   setFont('bold', 8.5); setTxt(Theme.dark);
//   doc.text('ASSESSMENT INTERPRETATION', ML + 5, y + 6.5);
//   setFont('normal', 8.5); setTxt(Theme.textDark);
//   const interpLines = doc.splitTextToSize(sanitizeText(interp), CW - 10);
//   doc.text(interpLines, ML + 5, y + 12.5);
//   y += 8 + interpLines.length * 5.5 + 10;

//   y = safeY(y, 50);
//   y = subHeading('Findings Overview by Severity', y);

//   autoTable(doc, {
//     startY: y,
//     head: [['Severity', 'Count', 'Applicable', 'Non-Applicable', 'Impact', 'Status']],
//     body: [
//       ['Critical', criticals.length, criticals.filter(i => i.evidence?.is_applicable !== false).length, criticals.filter(i => i.evidence?.is_applicable === false).length, `-${criticals.reduce((s, i) => s + Math.abs(i.score_impact), 0)}`, criticals.length > 0 ? 'IMMEDIATE ACTION' : 'NONE'],
//       ['High', highs.length, highs.filter(i => i.evidence?.is_applicable !== false).length, highs.filter(i => i.evidence?.is_applicable === false).length, `-${highs.reduce((s, i) => s + Math.abs(i.score_impact), 0)}`, highs.length > 0 ? 'ACTION REQUIRED' : 'NONE'],
//       ['Medium', mediums.length, mediums.filter(i => i.evidence?.is_applicable !== false).length, mediums.filter(i => i.evidence?.is_applicable === false).length, `-${mediums.reduce((s, i) => s + Math.abs(i.score_impact), 0)}`, mediums.length > 0 ? 'PLAN REMEDIATION' : 'NONE'],
//       ['Low', lows.length, lows.filter(i => i.evidence?.is_applicable !== false).length, lows.filter(i => i.evidence?.is_applicable === false).length, `-${lows.reduce((s, i) => s + Math.abs(i.score_impact), 0)}`, lows.length > 0 ? 'MONITOR' : 'NONE'],
//       ['TOTAL', findings.length, findings.filter(i => i.evidence?.is_applicable !== false).length, findings.filter(i => i.evidence?.is_applicable === false).length, `-${findings.reduce((s, i) => s + Math.abs(i.score_impact), 0)}`, '—'],
//     ],
//     theme: 'grid',
//     headStyles: { fillColor: Theme.bgLight, textColor: Theme.dark, fontSize: 8.5, fontStyle: 'bold', cellPadding: 4, lineColor: Theme.border, lineWidth: 0.1 },
//     bodyStyles: { fontSize: 8.5, textColor: Theme.textDark, cellPadding: 4, lineColor: Theme.border, lineWidth: 0.1 },
//     columnStyles: { 0: { fontStyle: 'bold' }, 1: { halign: 'center' }, 2: { halign: 'center' }, 3: { halign: 'center' }, 4: { halign: 'center' }, 5: { fontStyle: 'bold' } },
//     didParseCell: (data: any) => {
//       if (data.section !== 'body') return;
//       const sev = data.row.raw[0];
//       const isLast = sev === 'TOTAL';
//       if (isLast) { data.cell.styles.fillColor = Theme.bgLight; data.cell.styles.fontStyle = 'bold'; return; }
//       if (data.column.index === 0 || (data.column.index === 5 && !isLast)) {
//         data.cell.styles.textColor = getSevColor(sev);
//       }
//     },
//     margin: { left: ML, right: MR },
//   });
//   y = (doc as any).lastAutoTable.finalY + 12;

//   // ═══════════════════════════════════════════════════════════════════════════
//   // DETAILED FINDINGS PAGES
//   // ═══════════════════════════════════════════════════════════════════════════
//   const severityGroups = [
//     { label: 'Critical Severity Findings', items: criticals, color: Theme.crit },
//     { label: 'High Severity Findings', items: highs, color: Theme.high },
//     { label: 'Medium Severity Findings', items: mediums, color: Theme.med },
//     { label: 'Low Severity Findings', items: lows, color: Theme.low },
//   ];

//   let globalFindingNum = 0;

//   for (const group of severityGroups) {
//     if (!group.items.length) continue;

//     addPage();
//     y = BODY_TOP;
//     y = sectionHeader(group.label, `${group.items.length} finding(s) in this category`, y);

//     setFont('normal', 9.5); setTxt(Theme.textDark);
//     const gdLines = doc.splitTextToSize(`The following section details each ${group.items[0]?.severity} severity finding identified during the assessment. Each finding includes a technical description, evidence, remediation guidance, and applicability context.`, CW);
//     doc.text(gdLines, ML, y); y += gdLines.length * 5.5 + 8;

//     autoTable(doc, {
//       startY: y,
//       head: [['#', 'Indicator Name', 'Category', 'Impact', 'Applicable', 'Affected Endpoints']],
//       body: group.items.map((f, i) => [
//         `${globalFindingNum + i + 1}`, 
//         sanitizeText(f.indicator_name), 
//         sanitizeText(f.category), 
//         `-${Math.abs(f.score_impact)} pts`, 
//         f.evidence?.is_applicable !== false ? 'Yes' : 'No', 
//         getAffectedEndpointsFromScan(f, scan).length > 0 ? `${getAffectedEndpointsFromScan(f, scan).length}` : '—',
//       ]),
//       theme: 'grid',
//       headStyles: { fillColor: Theme.bgLight, textColor: Theme.dark, fontSize: 8, fontStyle: 'bold', cellPadding: 3, lineColor: Theme.border, lineWidth: 0.1 },
//       bodyStyles: { fontSize: 8, textColor: Theme.textDark, cellPadding: 3, lineColor: Theme.border, lineWidth: 0.1 },
//       margin: { left: ML, right: MR },
//     });

//     for (const finding of group.items) {
//       globalFindingNum++;
//       addPage();
//       y = BODY_TOP;

//       const sColor = getSevColor(finding.severity);

//       setFill(Theme.bgLight); setDraw(Theme.border); doc.setLineWidth(0.2);
//       doc.roundedRect(ML, y, CW, 20, 1.5, 1.5, 'FD');
//       setFill(sColor); doc.rect(ML, y, 4, 20, 'F'); 

//       setFont('bold', 10); setTxt(Theme.textMuted);
//       doc.text(`FINDING #${globalFindingNum}`, ML + 10, y + 7);
      
//       setFont('bold', 12); setTxt(Theme.dark);
//       const nameLines = doc.splitTextToSize(sanitizeText(finding.indicator_name || 'Unknown Indicator'), CW - 50);
//       doc.text(nameLines[0], ML + 10, y + 14);

//       pill(finding.severity.toUpperCase(), PW - MR, y + 10, sColor);
//       y += 28;

//       const metaCols = [
//         ['Category', sanitizeText(finding.category || 'N/A')],
//         ['Score Impact', `-${Math.abs(finding.score_impact || 0)} pts`],
//         ['Applicable', finding.evidence?.is_applicable !== false ? 'Yes (Production)' : 'No (Non-Prod)'],
//         ['Environment', sanitizeText(finding.evidence?.environment || 'Unknown')],
//       ];
//       const mW = (CW - 6) / 4;
//       metaCols.forEach(([lbl, val], idx) => {
//         const mx = ML + idx * (mW + 2);
//         setFill(Theme.white); setDraw(Theme.border); doc.setLineWidth(0.2); doc.roundedRect(mx, y, mW, 16, 1, 1, 'FD');
//         setFont('bold', 7.5); setTxt(Theme.textMuted); doc.text(lbl.toUpperCase(), mx + 3, y + 5.5);
//         setFont('normal', 9); setTxt(Theme.textDark);
//         const vLines = doc.splitTextToSize(val, mW - 6);
//         doc.text(vLines[0], mx + 3, y + 11.5);
//       });
//       y += 22;

//       if (finding.endpoint_url) {
//         setFont('normal', 8.5); setTxt(Theme.textMuted);
//         doc.text(`Endpoint: ${sanitizeText(finding.endpoint_url)}`, ML, y); y += 8;
//       }

//       const affectedEndpoints = getAffectedEndpointsFromScan(finding, scan);
//       if (affectedEndpoints.length > 0) {
//         y = affectedEndpointsBlock(affectedEndpoints, y);
//       }

//       y = textBlock('Description & Risk Impact', finding.description, y);
//       y = textBlock('Remediation Recommendation', finding.recommendation, y);

//       if (finding.evidence) {
//         y = safeY(y, 25);
//         setFont('bold', 8.5); setTxt(Theme.dark);
//         doc.text('TECHNICAL EVIDENCE', ML, y);
//         y += 5;
//         const evText = formatEvidence(finding.evidence);
//         y = evidenceBlock(evText, y);
//       }

//       if (finding.evidence?.is_applicable === false) {
//         y = safeY(y, 20);
//         setFill([255, 248, 220] as RGB); setDraw(Theme.med); doc.setLineWidth(0.3);
//         doc.roundedRect(ML, y, CW, 14, 1.5, 1.5, 'FD');
//         setFont('bold', 8.5); setTxt(Theme.med);
//         doc.text('⚠ NON-PRODUCTION NOTE', ML + 5, y + 6);
//         setFont('normal', 8); setTxt(Theme.textDark);
//         doc.text('This finding originates from a non-production subdomain and is excluded from the overall risk score.', ML + 5, y + 11.5);
//         y += 20;
//       }
//     }
//   }

//   // ═══════════════════════════════════════════════════════════════════════════
//   // COMPLETE FINDINGS SUMMARY TABLE
//   // ═══════════════════════════════════════════════════════════════════════════
//   addPage();
//   y = BODY_TOP;
//   y = sectionHeader('Complete Findings Summary', `${findings.length} findings across all severities`, y);

//   autoTable(doc, {
//     startY: y,
//     head: [['#', 'Indicator', 'Category', 'Severity', 'Impact', 'Prod?', 'Endpoints', 'Summary Recommendation']],
//     body: findings.map((f, idx) => [
//       `${idx + 1}`, 
//       sanitizeText(f.indicator_name), 
//       sanitizeText(f.category), 
//       f.severity, 
//       `-${Math.abs(f.score_impact)}`, 
//       f.evidence?.is_applicable !== false ? '✓' : '✗', 
//       getAffectedEndpointsFromScan(f, scan).length > 0 ? `${getAffectedEndpointsFromScan(f, scan).length}` : '—', 
//       sanitizeText((f.recommendation || '').substring(0, 60) + ((f.recommendation?.length || 0) > 60 ? '…' : '')),
//     ]),
//     theme: 'grid',
//     headStyles: { fillColor: Theme.bgLight, textColor: Theme.dark, fontSize: 7.5, fontStyle: 'bold', cellPadding: 2.5, lineColor: Theme.border, lineWidth: 0.1 },
//     bodyStyles: { fontSize: 7.5, textColor: Theme.textDark, cellPadding: 2.5, valign: 'top', lineColor: Theme.border, lineWidth: 0.1 },
//     columnStyles: {
//       0: { cellWidth: 6, halign: 'center' },
//       1: { cellWidth: 30, fontStyle: 'bold' },
//       2: { cellWidth: 22 },
//       3: { cellWidth: 14, halign: 'center' },
//       4: { cellWidth: 10, halign: 'center' },
//       5: { cellWidth: 8, halign: 'center' },
//       6: { cellWidth: 12, halign: 'center' },
//       7: {},
//     },
//     didParseCell: (data: any) => {
//       if (data.section !== 'body') return;
//       if (data.column.index === 3) {
//         data.cell.styles.textColor = getSevColor(data.cell.raw);
//         data.cell.styles.fontStyle = 'bold';
//       }
//       if (data.column.index === 5) {
//         data.cell.styles.textColor = data.cell.raw === '✓' ? Theme.low : Theme.high;
//         data.cell.styles.fontStyle = 'bold';
//       }
//     },
//     margin: { left: ML, right: MR },
//   });

//   // ═══════════════════════════════════════════════════════════════════════════
//   // PASSING CONTROLS TABLE
//   // ═══════════════════════════════════════════════════════════════════════════
//   if (passing.length > 0) {
//     addPage();
//     y = BODY_TOP;
//     y = sectionHeader('Passing Controls', `${passing.length} controls with no issues detected`, y);

//     setFont('normal', 9); setTxt(Theme.textDark);
//     doc.text('The following security controls were evaluated and found to be satisfactory. No issues were detected.', ML, y);
//     y += 10;

//     autoTable(doc, {
//       startY: y,
//       head: [['#', 'Indicator Name', 'Category', 'Score Impact', 'Status']],
//       body: passing.map((f, i) => [
//         `${i + 1}`, 
//         sanitizeText(f.indicator_name), 
//         sanitizeText(f.category), 
//         f.score_impact > 0 ? `+${f.score_impact}` : '0', 
//         'PASS',
//       ]),
//       theme: 'grid',
//       headStyles: { fillColor: Theme.bgLight, textColor: Theme.dark, fontSize: 8, fontStyle: 'bold', cellPadding: 3, lineColor: Theme.border, lineWidth: 0.1 },
//       bodyStyles: { fontSize: 8, textColor: Theme.textDark, cellPadding: 3, lineColor: Theme.border, lineWidth: 0.1 },
//       columnStyles: { 0: { cellWidth: 8, halign: 'center' }, 1: { fontStyle: 'bold' }, 2: { cellWidth: 32 }, 3: { cellWidth: 20, halign: 'center' }, 4: { cellWidth: 18, halign: 'center', textColor: Theme.low, fontStyle: 'bold' } },
//       margin: { left: ML, right: MR },
//     });
//   }

//   // ═══════════════════════════════════════════════════════════════════════════
//   // APPLICABILITY ANALYSIS 
//   // ═══════════════════════════════════════════════════════════════════════════
//   addPage();
//   y = BODY_TOP;
//   y = sectionHeader('Applicability Analysis', 'Production vs Non-Production breakdown', y);

//   setFont('normal', 9.5); setTxt(Theme.textDark);
//   const appLines = doc.splitTextToSize('Findings originating from non-production subdomains (dev, test, staging, qa, sandbox, uat) are marked "Not Applicable" and excluded from the overall risk score calculation. This distinction ensures that only production-impacting vulnerabilities influence vendor risk ratings.', CW);
//   doc.text(appLines, ML, y); y += appLines.length * 5.5 + 10;

//   y = subHeading('Applicability Breakdown by Severity', y);

//   autoTable(doc, {
//     startY: y,
//     head: [['Severity', 'Total Findings', 'Production (Applicable)', 'Non-Production (Excluded)', '% Applicable']],
//     body: [
//       ['Critical', criticals.length, criticals.filter(i => i.evidence?.is_applicable !== false).length, criticals.filter(i => i.evidence?.is_applicable === false).length, criticals.length ? `${Math.round(criticals.filter(i => i.evidence?.is_applicable !== false).length / criticals.length * 100)}%` : '—'],
//       ['High', highs.length, highs.filter(i => i.evidence?.is_applicable !== false).length, highs.filter(i => i.evidence?.is_applicable === false).length, highs.length ? `${Math.round(highs.filter(i => i.evidence?.is_applicable !== false).length / highs.length * 100)}%` : '—'],
//       ['Medium', mediums.length, mediums.filter(i => i.evidence?.is_applicable !== false).length, mediums.filter(i => i.evidence?.is_applicable === false).length, mediums.length ? `${Math.round(mediums.filter(i => i.evidence?.is_applicable !== false).length / mediums.length * 100)}%` : '—'],
//       ['Low', lows.length, lows.filter(i => i.evidence?.is_applicable !== false).length, lows.filter(i => i.evidence?.is_applicable === false).length, lows.length ? `${Math.round(lows.filter(i => i.evidence?.is_applicable !== false).length / lows.length * 100)}%` : '—'],
//       ['TOTAL', findings.length, findings.filter(i => i.evidence?.is_applicable !== false).length, findings.filter(i => i.evidence?.is_applicable === false).length, findings.length ? `${Math.round(findings.filter(i => i.evidence?.is_applicable !== false).length / findings.length * 100)}%` : '—'],
//     ],
//     theme: 'grid',
//     headStyles: { fillColor: Theme.bgLight, textColor: Theme.dark, fontSize: 8.5, fontStyle: 'bold', cellPadding: 3.5, lineColor: Theme.border, lineWidth: 0.1 },
//     bodyStyles: { fontSize: 8.5, textColor: Theme.textDark, cellPadding: 3.5, lineColor: Theme.border, lineWidth: 0.1 },
//     columnStyles: { 0: { fontStyle: 'bold', cellWidth: 22 }, 1: { halign: 'center' }, 2: { halign: 'center' }, 3: { halign: 'center' }, 4: { halign: 'center', fontStyle: 'bold' } },
//     didParseCell: (data: any) => {
//       if (data.section === 'body' && data.column.index === 0) {
//         const sev = data.cell.raw;
//         if (sev === 'TOTAL') { data.cell.styles.fillColor = Theme.bgLight; data.cell.styles.fontStyle = 'bold'; return; }
//         data.cell.styles.textColor = getSevColor(sev);
//       }
//     },
//     margin: { left: ML, right: MR },
//   });

//   // ═══════════════════════════════════════════════════════════════════════════
//   // REMEDIATION ROADMAP
//   // ═══════════════════════════════════════════════════════════════════════════
//   addPage();
//   y = BODY_TOP;
//   y = sectionHeader('Remediation Roadmap', 'Prioritized action plan', y);

//   const phases = [
//     { label: 'Phase 1 — Immediate (0–7 days)', color: Theme.crit, items: criticals.filter(i => i.evidence?.is_applicable !== false) },
//     { label: 'Phase 2 — Short Term (7–30 days)', color: Theme.high, items: highs.filter(i => i.evidence?.is_applicable !== false) },
//     { label: 'Phase 3 — Medium Term (30–90 days)', color: Theme.med, items: mediums.filter(i => i.evidence?.is_applicable !== false) },
//     { label: 'Phase 4 — Long Term (90+ days)', color: Theme.low, items: lows.filter(i => i.evidence?.is_applicable !== false) },
//   ];

//   for (const phase of phases) {
//     if (!phase.items.length) continue;
//     y = safeY(y, 30);

//     setFont('bold', 10); setTxt(phase.color);
//     doc.text(phase.label, ML, y);
//     setFont('normal', 8.5); setTxt(Theme.textMuted);
//     doc.text(`${phase.items.length} finding(s)`, PW - MR, y, { align: 'right' });
//     y += 3;
//     setDraw(Theme.border); doc.setLineWidth(0.2); doc.line(ML, y, PW - MR, y);
//     y += 4;

//     autoTable(doc, {
//       startY: y,
//       head: [['Indicator', 'Category', 'Impact', 'Recommended Action']],
//       body: phase.items.map(f => [
//         sanitizeText(f.indicator_name), 
//         sanitizeText(f.category), 
//         `-${Math.abs(f.score_impact)} pts`, 
//         sanitizeText((f.recommendation || 'Review and remediate.').substring(0, 100) + ((f.recommendation?.length || 0) > 100 ? '…' : '')),
//       ]),
//       theme: 'plain',
//       headStyles: { textColor: Theme.textMuted, fontSize: 8, fontStyle: 'bold', cellPadding: 3 },
//       bodyStyles: { fontSize: 8.5, textColor: Theme.textDark, cellPadding: 3 },
//       columnStyles: { 0: { cellWidth: 40, fontStyle: 'bold' }, 1: { cellWidth: 28 }, 2: { cellWidth: 16, halign: 'center', fontStyle: 'bold' }, 3: {} },
//       margin: { left: ML, right: MR },
//     });
//     y = (doc as any).lastAutoTable.finalY + 12;
//   }

//   // ═══════════════════════════════════════════════════════════════════════════
//   // FINAL PAGE — DISCLAIMER & CERTIFICATION 
//   // ═══════════════════════════════════════════════════════════════════════════
//   addPage();
//   y = BODY_TOP;
//   y = sectionHeader('Disclaimer & Certification', '', y);

//   const disclaimerSections = [
//     { title: '1. Scope & Methodology', body: 'This assessment was performed using non-intrusive, passive external reconnaissance and OSINT-based techniques. No active exploitation, intrusive scanning, or unauthorized access was performed. All findings are derived from publicly observable signals and passive data sources. Results represent a point-in-time snapshot and may not capture all potential security risks.' },
//     { title: '2. Confidentiality Notice', body: `This report is classified CONFIDENTIAL and is intended solely for the authorized recipient organization. Redistribution, reproduction, publication, or disclosure of this report or any portion thereof to unauthorized third parties without prior written consent is strictly prohibited. Report ID: ${reportId}.` },
//     { title: '3. Applicability of Findings', body: 'Findings marked as "Not Applicable" originate from non-production subdomains (dev, staging, test, qa, sandbox, uat, etc.) and are explicitly excluded from the vendor risk score calculation. This policy ensures that only production-facing vulnerabilities contribute to the vendor\'s overall risk rating.' },
//     { title: '4. Limitations', body: 'The assessment evaluates externally observable indicators only. Internal controls, policies, and compensating measures implemented by the vendor but not visible externally are not reflected in this report. This assessment should be used as one input among several in a comprehensive third-party risk management program.' },
//     { title: '5. Liability', body: 'This report is provided for informational purposes only. The issuing organization makes no warranties, express or implied, as to the completeness or accuracy of the information herein. Decisions made based on this report are the sole responsibility of the recipient.' },
//   ];

//   for (const s of disclaimerSections) {
//     y = safeY(y, 28);
//     setFont('bold', 9.5); setTxt(Theme.dark);
//     doc.text(sanitizeText(s.title), ML, y); y += 4;
//     setFont('normal', 9); setTxt(Theme.textDark);
//     const sLines = doc.splitTextToSize(sanitizeText(s.body), CW);
//     if (y + sLines.length * 5 > BODY_BTM) { addPage(); y = BODY_TOP; }
//     doc.text(sLines, ML, y); y += sLines.length * 5 + 8;
//   }

//   // ═══════════════════════════════════════════════════════════════════════════
//   // GLOBAL HEADERS & FOOTERS 
//   // ═══════════════════════════════════════════════════════════════════════════
//   const totalPages = doc.getNumberOfPages();
//   for (let p = 1; p <= totalPages; p++) {
//     doc.setPage(p);

//     if (p > 1) {
//       setFont('bold', 8.5); setTxt(Theme.brand);
//       doc.text('AstraVault', ML, 12);
//       setFont('normal', 8.5); setTxt(Theme.textMuted);
//       doc.text(`|  Enterprise Assessment: ${sanitizeText(vendor.domain)}`, ML + 20, 12);
//       doc.text(sanitizeText(reportDate), PW - MR, 12, { align: 'right' });
//       setDraw(Theme.border); doc.setLineWidth(0.2); doc.line(ML, 16, PW - MR, 16);
//     }

//     setDraw(Theme.border); doc.setLineWidth(0.2); doc.line(ML, PH - FOOTER_H, PW - MR, PH - FOOTER_H);
//     setFont('normal', 8); setTxt(Theme.textMuted);
//     doc.text('Powered by AstraVault Platform  •  CONFIDENTIAL', ML, PH - 10);
//     doc.text(`Report ID: ${sanitizeText(reportId)}`, PW / 2, PH - 10, { align: 'center' });
//     setFont('bold', 8);
//     doc.text(`Page ${p} of ${totalPages}`, PW - MR, PH - 10, { align: 'right' });
//   }

//   return doc;
// }

// // ═══════════════════════════════════════════════════════════════════════════════
// // REACT COMPONENT
// // ═══════════════════════════════════════════════════════════════════════════════
// export default function Reports() {
//   const { enqueueSnackbar } = useSnackbar();
//   const [vendors, setVendors]           = useState<Vendor[]>([]);
//   const [scans, setScans]               = useState<Scan[]>([]);
//   const [selectedVendor, setSelectedVendor] = useState<Vendor | null>(null);
//   const [loading, setLoading]           = useState(true);
//   const [generating, setGenerating]     = useState(false);
//   const [dialogOpen, setDialogOpen]     = useState(false);
//   const [reportFormat, setReportFormat] = useState('pdf');

//   useEffect(() => { fetchData(); }, []);

//   const fetchData = async () => {
//   try {
//     // Fetch vendors and scans in parallel
//     const [vendorsRes, scansRes] = await Promise.all([
//       api.get('/v1/vendors'),
//       api.get('/v1/scans?limit=1000'),
//     ]);

//     // Process vendors
//     let vendorsData = vendorsRes.data;
//     if (vendorsData?.vendors) vendorsData = vendorsData.vendors;
//     else if (!Array.isArray(vendorsData)) vendorsData = [];
//     setVendors(vendorsData);

//     // Process scans - filter by vendor domains
//     let scansData = scansRes.data;
//     if (scansData?.scans) scansData = scansData.scans;
//     else if (!Array.isArray(scansData)) scansData = [];
    
//     // 🔥 FIX: Only keep scans that belong to the vendors in this tenant
//     const vendorDomains = vendorsData.map((v: Vendor) => v.domain);
//     const filteredScans = scansData.filter((s: any) => 
//       vendorDomains.includes(s.domain) || vendorDomains.includes(s.primary_domain)
//     );
    
//     // Remove duplicates
//     const uniqueScans = filteredScans.filter((s: any, i: number, arr: any[]) => 
//       i === arr.findIndex((x: any) => x.id === s.id)
//     );
//     setScans(uniqueScans);
    
//     console.log(`✅ Loaded ${vendorsData.length} vendors and ${uniqueScans.length} scans for this tenant`);

//   } catch (err) {
//     console.error('Failed to fetch data:', err);
//     enqueueSnackbar('Failed to load report data', { variant: 'error' });
//   } finally { 
//     setLoading(false); 
//   }
// };

// const getLatestScan = (vendor: Vendor): Scan | null => {
//   const vs = scans.filter(s => s.domain === vendor.domain);
//   if (!vs.length) return null;
//   return vs.sort((a, b) => new Date(b.completed_at).getTime() - new Date(a.completed_at).getTime())[0];
// };

// const generatePDF = async (vendor: Vendor) => {
//   const scan = getLatestScan(vendor);
//   if (!scan) { enqueueSnackbar('No scan data available', { variant: 'warning' }); return; }
//   setGenerating(true);
//   try {
//     // Fetch full scan details including endpoints_json ONLY when generating report
//     let fullScan = scan;
//     if (!scan.endpoints_json) {
//       try {
//         const detailRes = await api.get(`/v1/scan/${scan.id}`);
//         fullScan = { ...scan, endpoints_json: detailRes.data?.endpoints_json || [] };
//       } catch {
//         fullScan = { ...scan, endpoints_json: [] };
//       }
//     }
    
//     const doc = await buildVendorPDF(vendor, fullScan);
//     const reportId = `TPRM-${new Date().getFullYear()}-${String(Math.floor(Math.random() * 90000) + 10000)}`;
//     doc.save(`${vendor.name.toLowerCase().replace(/\s+/g, '_')}_security_report_${reportId}.pdf`);
//     enqueueSnackbar(`Report for ${vendor.name} generated successfully`, { variant: 'success' });
//   } catch (err) {
//     console.error(err);
//     enqueueSnackbar('Failed to generate PDF', { variant: 'error' });
//   } finally { setGenerating(false); }
// };

// const generateCSV = (vendor: Vendor) => {
//   const scan = getLatestScan(vendor);
//   if (!scan?.indicators) { enqueueSnackbar('No indicator data available', { variant: 'warning' }); return; }
  
//   // Parse indicators if needed
//   let indicators = scan.indicators;
//   if (typeof indicators === 'string') {
//     try { indicators = JSON.parse(indicators as any); } catch { indicators = []; }
//   }
//   if (!Array.isArray(indicators)) indicators = [];
  
//   const headers = ['Indicator Name', 'Category', 'Severity', 'Impact Score', 'Applicable', 'Environment', 'Affected Endpoints', 'Description', 'Recommendation', 'Evidence'];
//   const rows = indicators.map((i: Indicator) => {
//     const endpoints = getAffectedEndpointsFromScan(i, scan);
//     return [
//       i.indicator_name, i.category, i.severity, i.score_impact,
//       i.evidence?.is_applicable !== false ? 'Yes' : 'No',
//       i.evidence?.environment || 'Unknown',
//       endpoints.length > 0 ? endpoints.join('; ') : 'None',
//       `"${(i.description || '').replace(/"/g, '""')}"`,
//       `"${(i.recommendation || '').replace(/"/g, '""')}"`,
//       `"${formatEvidence(i.evidence).replace(/"/g, '""')}"`,
//     ];
//   });
//   const csv = [headers, ...rows].map(r => r.join(',')).join('\n');
//   const blob = new Blob([csv], { type: 'text/csv' });
//   const url = URL.createObjectURL(blob);
//   const a = document.createElement('a');
//   a.href = url; a.download = `${vendor.name.toLowerCase().replace(/\s+/g, '_')}_indicators.csv`;
//   a.click(); URL.revokeObjectURL(url);
//   enqueueSnackbar(`CSV exported for ${vendor.name}`, { variant: 'success' });
// };

//   if (loading) return (
//     <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
//       <CircularProgress size={48} thickness={4} />
//     </Box>
//   );

//   const avgScore = Math.round(vendors.reduce((s, v) => s + (v.score || 0), 0) / (vendors.length || 1));
//   const avgGrade = getScoreGrade(avgScore);

//   return (
//     <ThemeProvider theme={theme}>
//       <CssBaseline />
//       <Box sx={{ bgcolor: 'background.default', minHeight: '100vh', px: { xs: 2, md: 6 }, py: 5 }}>

//         <Box sx={{ mb: 5 }}>
//           <Typography variant="h4" gutterBottom>Reporting & Analytics</Typography>
//           <Typography variant="body1" color="text.secondary">
//             Generate professional vendor security reports with comprehensive findings and remediation guidance.
//           </Typography>
//         </Box>

//         {/* KPI Cards */}
//         <Grid container spacing={3} sx={{ mb: 6 }}>
//           {[
//             { label: 'Total Vendors', value: vendors.length, icon: <Business />, bg: '#EFF6FF', fg: '#2563EB' },
//             { label: 'Avg Portfolio Score', value: `${avgScore}/100`, icon: null, bg: `rgb(${avgGrade.bg.join(',')})`, fg: `rgb(${avgGrade.color.join(',')})` },
//             { label: 'Critical / High Risk', value: vendors.filter(v => ['high', 'critical'].includes(v.riskLevel?.toLowerCase())).length, icon: <WarningIcon />, bg: '#FEF2F2', fg: '#DC2626' },
//             // In the KPI cards, change:
// { label: 'Total Scans', value: scans.length, icon: <Shield />, bg: '#F8FAFC', fg: '#475569' },
//           ].map((kpi, i) => (
//             <Grid key={i} size={{ xs: 12, sm: 6, md: 3 }}>
//               <Card sx={{ height: '100%' }}>
//                 <CardContent sx={{ p: 3 }}>
//                   <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
//                     <Box>
//                       <Typography variant="subtitle2" color="text.secondary" gutterBottom>{kpi.label}</Typography>
//                       <Typography variant="h4" sx={{ mt: 1 }}>{kpi.value}</Typography>
//                     </Box>
//                     {kpi.icon
//                       ? <Box sx={{ p: 1.5, bgcolor: kpi.bg, borderRadius: 2, color: kpi.fg, display: 'flex' }}>{kpi.icon}</Box>
//                       : <Box sx={{ width: 48, height: 48, borderRadius: 2, display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: kpi.bg, color: kpi.fg, fontWeight: 800, fontSize: '1.5rem' }}>{avgGrade.letter}</Box>
//                     }
//                   </Box>
//                 </CardContent>
//               </Card>
//             </Grid>
//           ))}
//         </Grid>

//         {/* Report Cards */}
//         <Typography variant="h6" sx={{ mb: 3 }}>Generate Reports</Typography>
//         <Grid container spacing={4} sx={{ mb: 6 }}>
//           <Grid size={{ xs: 12, md: 6 }}>
//             <Card sx={{ '&:hover': { borderColor: '#94A3B8', transform: 'translateY(-2px)' }, transition: 'all 0.2s' }}>
//               <CardContent sx={{ p: 4 }}>
//                 <Box sx={{ display: 'flex', alignItems: 'center', gap: 2.5, mb: 3 }}>
//                   <Box sx={{ p: 2, bgcolor: '#F1F5F9', borderRadius: 2.5, color: '#0F172A', display: 'flex' }}><PictureAsPdf fontSize="large" /></Box>
//                   <Box>
//                     <Typography variant="h6">Professional Security Report</Typography>
//                     <Typography variant="caption" color="text.secondary">Multi-page PDF — Cover, ToC, Executive Summary, Detailed Findings with Endpoints, Roadmap</Typography>
//                   </Box>
//                 </Box>
//                 <Typography variant="body2" color="text.secondary" sx={{ mb: 4, lineHeight: 1.7 }}>
//                   Industry-standard PDF with cover page, table of contents, executive summary, per-finding detail pages with affected endpoints, complete findings table, passing controls, applicability analysis, prioritized remediation roadmap, and legal disclaimer.
//                 </Typography>
//                 <Button variant="contained" color="primary" size="large" fullWidth
//                   onClick={() => { setReportFormat('pdf'); setDialogOpen(true); }}
//                   disabled={generating}
//                   startIcon={generating ? <CircularProgress size={20} color="inherit" /> : <Download />}>
//                   {generating ? 'Generating...' : 'Generate PDF Report'}
//                 </Button>
//               </CardContent>
//             </Card>
//           </Grid>
//           <Grid size={{ xs: 12, md: 6 }}>
//             <Card sx={{ '&:hover': { borderColor: '#94A3B8', transform: 'translateY(-2px)' }, transition: 'all 0.2s' }}>
//               <CardContent sx={{ p: 4 }}>
//                 <Box sx={{ display: 'flex', alignItems: 'center', gap: 2.5, mb: 3 }}>
//                   <Box sx={{ p: 2, bgcolor: '#F1F5F9', borderRadius: 2.5, color: '#0F172A', display: 'flex' }}><FileCopy fontSize="large" /></Box>
//                   <Box>
//                     <Typography variant="h6">Raw Telemetry Export</Typography>
//                     <Typography variant="caption" color="text.secondary">CSV — All indicators with affected endpoints, applicability, and evidence</Typography>
//                   </Box>
//                 </Box>
//                 <Typography variant="body2" color="text.secondary" sx={{ mb: 4, lineHeight: 1.7 }}>
//                   Complete dataset of all evaluated security controls with severity, score impacts, affected endpoints, applicability status, environment labels, and raw technical evidence in CSV format for further analysis.
//                 </Typography>
//                 <Button variant="outlined" size="large" color="primary" fullWidth
//                   onClick={() => { setReportFormat('csv'); setDialogOpen(true); }}
//                   startIcon={<FileCopy />}>
//                   Export CSV Data
//                 </Button>
//               </CardContent>
//             </Card>
//           </Grid>
//         </Grid>

//         {/* Export Dialog */}
//         <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)} maxWidth="sm" fullWidth>
//           <DialogTitle sx={{ pb: 1, fontWeight: 700 }}>Export Configuration</DialogTitle>
//           <DialogContent>
//             <Stack spacing={3} sx={{ mt: 2 }}>
//               <FormControl fullWidth>
//                 <InputLabel>Target Vendor</InputLabel>
//                 <Select
//                   value={selectedVendor?.id || ''}
//                   onChange={e => setSelectedVendor(vendors.find(v => v.id === e.target.value) || null)}
//                   label="Target Vendor">
//                   {vendors.map(v => {
//                     const g = getScoreGrade(v.score || 0);
//                     return (
//                       <MenuItem key={v.id} value={v.id} sx={{ py: 1.5 }}>
//                         <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
//                           <Box>
//                             <Typography variant="body2" fontWeight={600}>{v.name}</Typography>
//                             <Typography variant="caption" color="text.secondary">{v.domain}</Typography>
//                           </Box>
//                           <Chip label={`${v.score || 'N/A'} / 100`} size="small"
//                             sx={{ fontWeight: 700, bgcolor: `rgb(${g.bg.join(',')})`, color: `rgb(${g.color.join(',')})` }} />
//                         </Box>
//                       </MenuItem>
//                     );
//                   })}
//                 </Select>
//               </FormControl>

//               <FormControl>
//                 <Typography variant="subtitle2" gutterBottom color="text.secondary">Output Format</Typography>
//                 <RadioGroup value={reportFormat} onChange={e => setReportFormat(e.target.value)} row>
//                   <FormControlLabel value="pdf" control={<Radio color="primary" />} label={<Typography fontWeight={500}>PDF Document</Typography>} />
//                   <FormControlLabel value="csv" control={<Radio color="primary" />} label={<Typography fontWeight={500}>CSV Spreadsheet</Typography>} sx={{ ml: 2 }} />
//                 </RadioGroup>
//               </FormControl>

//               {reportFormat === 'pdf' && (
//                 <Alert severity="info">
//                   <AlertTitle sx={{ fontWeight: 600 }}>PDF Report Sections</AlertTitle>
//                   <Box component="ul" sx={{ pl: 2, m: 0, mt: 0.5, fontSize: '0.875rem' }}>
//                     <li>Cover Page with Risk Score</li>
//                     <li>Table of Contents</li>
//                     <li>Executive Summary &amp; Score Analysis</li>
//                     <li>Per-Finding Detail Pages with Affected Endpoints</li>
//                     <li>Complete Findings Summary Table</li>
//                     <li>Passing Controls List</li>
//                     <li>Applicability Analysis (Prod vs Non-Prod)</li>
//                     <li>Prioritized Remediation Roadmap</li>
//                     <li>Legal Disclaimer &amp; Certification</li>
//                   </Box>
//                 </Alert>
//               )}
//             </Stack>
//           </DialogContent>
//           <DialogActions sx={{ p: 3 }}>
//             <Button onClick={() => setDialogOpen(false)} sx={{ color: '#64748B' }}>Cancel</Button>
//             <Button variant="contained" color="primary" size="large" disabled={generating}
//               onClick={() => {
//                 if (!selectedVendor) { enqueueSnackbar('Please select a vendor', { variant: 'warning' }); return; }
//                 setDialogOpen(false);
//                 if (reportFormat === 'pdf') generatePDF(selectedVendor);
//                 else generateCSV(selectedVendor);
//               }}
//               sx={{ px: 4 }}>
//               {generating ? 'Processing…' : `Generate ${reportFormat.toUpperCase()}`}
//             </Button>
//           </DialogActions>
//         </Dialog>

//         {/* Vendor Risk Register */}
//         <Paper sx={{ overflow: 'hidden', mt: 2, border: '1px solid #E2E8F0' }}>
//           <Box sx={{ p: 3, borderBottom: '1px solid #E2E8F0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//             <Typography variant="h6">Vendor Risk Register</Typography>
//             <Chip label={`${vendors.length} Active Vendors`} size="small" sx={{ bgcolor: '#F1F5F9', color: '#475569', fontWeight: 600 }} />
//           </Box>
//           <TableContainer>
//             <Table size="medium">
//               <TableHead>
//                 <TableRow>
//                   <TableCell>Organization</TableCell>
//                   <TableCell>Security Score</TableCell>
//                   <TableCell>Risk Level</TableCell>
//                   <TableCell>Last Assessment</TableCell>
//                   <TableCell>Status</TableCell>
//                   <TableCell align="right">Actions</TableCell>
//                 </TableRow>
//               </TableHead>
//               <TableBody>
//                 {vendors.map(vendor => {
//                   const g = getScoreGrade(vendor.score || 0);
//                   return (
//                     <TableRow key={vendor.id} hover>
//                       <TableCell>
//                         <Typography variant="subtitle2">{vendor.name}</Typography>
//                         <Typography variant="caption" color="text.secondary">{vendor.domain}</Typography>
//                       </TableCell>
//                       <TableCell>
//                         <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
//                           <Box sx={{ width: 32, height: 32, borderRadius: 1.5, display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: `rgb(${g.bg.join(',')})`, color: `rgb(${g.color.join(',')})`, fontWeight: 700, fontSize: '0.875rem' }}>
//                             {g.letter}
//                           </Box>
//                           <Typography variant="body2" fontWeight={600}>{vendor.score}</Typography>
//                         </Box>
//                       </TableCell>
//                       <TableCell>
//                         <Chip label={getRiskLevelText(vendor.riskLevel)} size="small" sx={{
//                           fontWeight: 600, fontSize: '0.75rem',
//                           bgcolor: vendor.riskLevel?.toLowerCase() === 'low' ? '#D1FAE5' : vendor.riskLevel?.toLowerCase() === 'medium' ? '#FEF3C7' : vendor.riskLevel?.toLowerCase() === 'high' ? '#FFEDD5' : '#FEE2E2',
//                           color: vendor.riskLevel?.toLowerCase() === 'low' ? '#065F46' : vendor.riskLevel?.toLowerCase() === 'medium' ? '#92400E' : vendor.riskLevel?.toLowerCase() === 'high' ? '#9A3412' : '#991B1B',
//                         }} />
//                       </TableCell>
//                       <TableCell>
//                         <Typography variant="body2" color="text.secondary">
//                           {vendor.lastScan ? new Date(vendor.lastScan).toLocaleDateString() : 'Pending'}
//                         </Typography>
//                       </TableCell>
//                       <TableCell>
//                         <Chip label={vendor.status || 'Active'} size="small" sx={{ bgcolor: '#F1F5F9', color: '#475569' }} />
//                       </TableCell>
//                       <TableCell align="right">
//                         <Tooltip title="Generate PDF Report">
//                           <IconButton size="small"
//                             onClick={() => { setSelectedVendor(vendor); generatePDF(vendor); }}
//                             sx={{ color: '#64748B', '&:hover': { color: '#2563EB', bgcolor: '#EFF6FF' } }}>
//                             <Description fontSize="small" />
//                           </IconButton>
//                         </Tooltip>
//                       </TableCell>
//                     </TableRow>
//                   );
//                 })}
//               </TableBody>
//             </Table>
//           </TableContainer>
//         </Paper>
//       </Box>
//     </ThemeProvider>
//   );
// }

import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useMutation, useQuery } from '@tanstack/react-query';
import { useSearchParams } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import { useTheme as useCustomTheme } from '../../context/ThemeContext';
import { useAuth } from '../../context/AuthContext';
import api from '../../services/api';
import { vendorQueries, myRiskQueries, reportQueries } from '../../lib/queries';
import { T, sans } from '../Vendors/VendorDetails';
import { VendorLogo } from '../VendorRequests/VendorRequests';
import {
  buildVendorReport, buildPortfolioReport, newReportId, gradeOf, fmtDate, daysSince,
  DEFAULT_VENDOR_OPTIONS, DEFAULT_PORTFOLIO_OPTIONS, DEFAULT_BOARD_OPTIONS, buildBoardReport, BoardReportData, BoardReportOptions,
  VendorReportData, PortfolioReportData, VendorReportOptions, PortfolioReportOptions, Classification, ReportMeta, ReportLogo,
} from './reportPdf';
import { findingsCsv, vendorRegisterCsv, downloadFile, slug, CsvResult } from './reportCsv';

/* ─── Report library ───────────────────────────────────────────────────────────────────────────── */
type TemplateId = 'board' | 'vendor-full' | 'vendor-brief' | 'portfolio' | 'findings-csv' | 'register-csv';
interface Template {
  id: TemplateId; name: string; format: 'PDF' | 'CSV'; scope: 'vendor' | 'portfolio';
  description: string; audience: string; length: string; includes: string[]; group: string;
}
const TEMPLATES: Template[] = [
  {
    id: 'board', name: 'Board Summary Report', format: 'PDF', scope: 'portfolio',
    description: "Your own rating next to your vendors', risk by business impact, monthly trends, biggest movers and talking points.",
    audience: 'Board & executives', length: '3 pages', group: 'Executive',
    includes: ['Headline & KPIs', 'Your rating by category', 'Your rating vs vendor average', 'Risk by business impact', 'Monthly rating distribution', 'Rating change (30 days)', 'Talking points & actions'],
  },
  {
    id: 'vendor-full', name: 'Security Report', format: 'PDF', scope: 'vendor',
    description: "One vendor in full: ratings by category, 12-month history, every risk with its recommendation, remediation and hosting.",
    audience: 'Security & risk teams', length: '15-25 pages', group: 'Vendor',
    includes: ['Cover', 'Introduction', 'Rating methodology', 'Company profile', 'Assessment summary', 'Risk count by severity', 'Remediation summary', 'Risk category breakdown', 'Geolocation', 'Fourth parties', 'Evidence used'],
  },
  {
    id: 'vendor-brief', name: 'Vendor Summary Report', format: 'PDF', scope: 'vendor',
    description: 'A short summary of one vendor for leadership, procurement and renewal reviews.',
    audience: 'Leadership & procurement', length: '4 pages', group: 'Vendor',
    includes: ['Assessment summary', 'Rating by category', 'Risk count by severity', 'Remediation summary', 'Fourth parties', 'Evidence used'],
  },
  {
    id: 'portfolio', name: 'Portfolio Risk Report', format: 'PDF', scope: 'portfolio',
    description: 'Every vendor ranked, with a category heatmap, top risks, recurring weaknesses and renewals.',
    audience: 'CISO & audit', length: '6-15 pages', group: 'Portfolio',
    includes: ['Cover & average rating', 'Executive summary', 'Rating distribution', 'Vendor ranking', 'Category heatmap', 'Top risks', 'Renewal calendar'],
  },
  {
    id: 'findings-csv', name: 'Findings Register', format: 'CSV', scope: 'vendor',
    description: "Every open finding of one vendor, ready for a GRC tool, ticket import or tracking sheet.",
    audience: 'GRC & remediation', length: 'Row per finding', group: 'Data export',
    includes: ['Finding ID & severity', 'Remediation target', 'Affected assets', 'Observation & recommendation', 'Evidence'],
  },
  {
    id: 'register-csv', name: 'Vendor Register', format: 'CSV', scope: 'portfolio',
    description: 'All vendors with score, grade, change, findings, owner, renewal date and category scores.',
    audience: 'Audit & procurement', length: 'Row per vendor', group: 'Data export',
    includes: ['Score & grade', 'Change since last scan', 'Findings by severity', 'Owner & lifecycle', 'Category scores'],
  },
];
const TEMPLATE_IDS = TEMPLATES.map(t => t.id);
const CLASSIFICATIONS: Classification[] = ['Confidential', 'Internal', 'Restricted'];
const SEVERITY_CUTS = ['Critical', 'High', 'Medium', 'Low'] as const;
type SeverityCut = typeof SEVERITY_CUTS[number];

const VENDOR_TOGGLES: { key: keyof VendorReportOptions; label: string; hint: string }[] = [
  { key: 'introduction', label: 'Introduction & methodology', hint: 'Severity levels and how ratings work' },
  { key: 'profile', label: 'Company profile', hint: 'Industry, owner, data sensitivity, contract' },
  { key: 'remediation', label: 'Remediation summary', hint: 'Active requests and risks in remediation' },
  { key: 'categories', label: 'Risk category breakdown', hint: 'One page per category with every risk' },
  { key: 'emptyCategories', label: 'Categories with no risks', hint: 'Show clean categories too' },
  { key: 'geolocation', label: 'Geolocation', hint: 'Hosting countries and providers' },
  { key: 'fourthParties', label: 'Fourth parties', hint: 'Providers the vendor depends on, with logos' },
  { key: 'evidenceUsed', label: 'Evidence used', hint: 'Domains, hosts and IPs assessed' },
];
const BOARD_TOGGLES: { key: keyof BoardReportOptions; label: string; hint: string }[] = [
  { key: 'distribution', label: 'Monthly rating distribution', hint: 'Vendors per grade, last 12 months' },
  { key: 'movers', label: 'Rating change (30 days)', hint: 'Movers, greatest decline and improvement' },
  { key: 'talkingPoints', label: 'Talking points & actions', hint: 'Where we stand and what to decide' },
];
const PORTFOLIO_TOGGLES: { key: keyof PortfolioReportOptions; label: string; hint: string }[] = [
  { key: 'heatmap', label: 'Category heatmap', hint: 'Every vendor across 14 categories' },
  { key: 'topRisks', label: 'Top risks', hint: 'Critical & high findings per vendor' },
  { key: 'calendar', label: 'Renewal calendar', hint: 'Stale assessments & contract ends' },
  { key: 'methodology', label: 'Methodology', hint: 'Scoring, grades and severities' },
];

/* ─── Small UI pieces ──────────────────────────────────────────────────────────────────────────── */
function usePalette(isDark: boolean) {
  return {
    bg: isDark ? '#000000' : T.bg, surface: isDark ? '#0d0d0d' : T.surface, surface2: isDark ? '#141414' : T.surface2,
    line: isDark ? '#1f1f1f' : T.bdr, lineStrong: isDark ? '#2e2e2e' : '#CBD5E1',
    ink: isDark ? '#e2e8f0' : T.ink, body: isDark ? '#cbd5e1' : '#334155', muted: isDark ? '#94a3b8' : T.slate, faint: isDark ? '#64748b' : T.muted,
    accent: isDark ? '#3B82F6' : '#2563EB', accentBg: isDark ? '#0f1e38' : '#EFF6FF',
    green: isDark ? '#4ADE80' : '#15803D', greenBg: isDark ? '#0b2214' : '#F0FDF4',
    amber: isDark ? '#FACC15' : '#B45309', amberBg: isDark ? '#241f08' : '#FFFBEB',
    red: isDark ? '#F87171' : '#B91C1C', redBg: isDark ? '#2a0f0f' : '#FEF2F2',
  };
}
type Pal = ReturnType<typeof usePalette>;

const scoreTone = (p: Pal, s: number | null | undefined) =>
  s == null ? { fg: p.faint, bg: p.surface2 } : s >= 80 ? { fg: p.green, bg: p.greenBg } : s >= 60 ? { fg: p.amber, bg: p.amberBg } : { fg: p.red, bg: p.redBg };

function ScoreChip({ score, p }: { score: number | null | undefined; p: Pal }) {
  const t = scoreTone(p, score);
  return (
    <span style={{ display: 'inline-flex', alignItems: 'baseline', gap: 4, padding: '2px 7px', borderRadius: 6, background: t.bg, color: t.fg, fontWeight: 800, fontSize: 12, whiteSpace: 'nowrap' }}>
      {score ?? '--'}<span style={{ fontSize: 10, fontWeight: 700, opacity: 0.85 }}>{score == null ? '' : gradeOf(score)}</span>
    </span>
  );
}

function FormatBadge({ format, p }: { format: 'PDF' | 'CSV'; p: Pal }) {
  const pdf = format === 'PDF';
  return (
    <span style={{
      fontSize: 9.5, fontWeight: 800, letterSpacing: '.06em', padding: '3px 6px', borderRadius: 4,
      color: pdf ? p.red : p.green, background: pdf ? p.redBg : p.greenBg,
    }}>{format}</span>
  );
}

function Switch({ on, onChange, p, label }: { on: boolean; onChange: (v: boolean) => void; p: Pal; label: string }) {
  return (
    <button type="button" role="switch" aria-checked={on} aria-label={label} onClick={() => onChange(!on)} style={{
      width: 32, height: 18, borderRadius: 9, border: 'none', padding: 2, cursor: 'pointer', flexShrink: 0,
      background: on ? p.accent : p.lineStrong, transition: 'background .15s', display: 'flex', justifyContent: on ? 'flex-end' : 'flex-start',
    }}>
      <span style={{ width: 14, height: 14, borderRadius: '50%', background: '#fff', boxShadow: '0 1px 2px rgba(0,0,0,.25)' }} />
    </button>
  );
}

function Segmented<V extends string>({ value, options, onChange, p }: { value: V; options: { v: V; label: string }[]; onChange: (v: V) => void; p: Pal }) {
  return (
    <div style={{ display: 'flex', border: `1px solid ${p.line}`, borderRadius: 7, padding: 2, background: p.surface2 }}>
      {options.map(o => (
        <button key={o.v} type="button" onClick={() => onChange(o.v)} style={{
          flex: 1, padding: '5px 6px', fontSize: 11.5, fontWeight: 600, borderRadius: 5, border: 'none', cursor: 'pointer', fontFamily: sans,
          background: value === o.v ? p.surface : 'transparent', color: value === o.v ? p.ink : p.muted,
          boxShadow: value === o.v ? '0 1px 2px rgba(15,23,42,.12)' : 'none',
        }}>{o.label}</button>
      ))}
    </div>
  );
}

const panel = (p: Pal): React.CSSProperties => ({ background: p.surface, border: `1px solid ${p.line}`, borderRadius: 10 });
const panelHead = (p: Pal): React.CSSProperties => ({ padding: '12px 16px', borderBottom: `1px solid ${p.line}`, display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8 });
const groupLabel = (p: Pal): React.CSSProperties => ({ fontSize: 10, fontWeight: 700, letterSpacing: '.08em', textTransform: 'uppercase', color: p.faint, marginBottom: 8 });
const btn = (p: Pal, primary = false, disabled = false): React.CSSProperties => ({
  display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: 6, padding: '8px 14px', borderRadius: 7,
  fontSize: 12.5, fontWeight: 650, fontFamily: sans, cursor: disabled ? 'default' : 'pointer', opacity: disabled ? 0.55 : 1,
  border: primary ? 'none' : `1px solid ${p.line}`, background: primary ? p.accent : p.surface, color: primary ? '#fff' : p.ink,
});

function useViewportWidth() {
  const [w, setW] = useState(() => window.innerWidth);
  useEffect(() => {
    const on = () => setW(window.innerWidth);
    window.addEventListener('resize', on);
    return () => window.removeEventListener('resize', on);
  }, []);
  return w;
}

/* ─── Vendor picker ────────────────────────────────────────────────────────────────────────────── */
interface PickVendor { id: string; name: string; domain: string; score: number | null; lastScan: string | null; self?: boolean }

function VendorPicker({ vendors, value, onChange, p, isDark }: { vendors: PickVendor[]; value: string; onChange: (id: string) => void; p: Pal; isDark: boolean }) {
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState('');
  const ref = useRef<HTMLDivElement>(null);
  const selected = vendors.find(v => v.id === value);
  useEffect(() => {
    if (!open) return;
    const close = (e: MouseEvent) => { if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false); };
    document.addEventListener('mousedown', close);
    return () => document.removeEventListener('mousedown', close);
  }, [open]);
  const shown = vendors.filter(v => !q || `${v.name} ${v.domain}`.toLowerCase().includes(q.toLowerCase()));

  const freshness = (v: PickVendor) => {
    const d = daysSince(v.lastScan);
    if (d == null) return <span style={{ color: p.faint }}>Never scanned</span>;
    return <span style={{ color: d > 30 ? p.amber : p.faint }}>{d === 0 ? 'Scanned today' : `Scanned ${d}d ago`}</span>;
  };

  return (
    <div ref={ref} style={{ position: 'relative' }}>
      <button type="button" onClick={() => setOpen(o => !o)} style={{
        width: '100%', display: 'flex', alignItems: 'center', gap: 10, padding: '8px 10px', borderRadius: 8, cursor: 'pointer',
        border: `1px solid ${open ? p.accent : p.line}`, background: p.surface, fontFamily: sans, textAlign: 'left',
      }}>
        {selected ? (
          <>
            <VendorLogo name={selected.name} domain={selected.domain} size={30} isDark={isDark} />
            <span style={{ flex: 1, minWidth: 0 }}>
              <span style={{ display: 'block', fontSize: 13, fontWeight: 650, color: p.ink, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                {selected.name}
              </span>
              <span style={{ display: 'block', fontSize: 11, color: p.muted, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                {selected.self && <span style={{ fontSize: 9.5, fontWeight: 800, color: p.accent, letterSpacing: '.05em', marginRight: 6 }}>YOUR COMPANY</span>}
                {selected.domain}
              </span>
            </span>
            <ScoreChip score={selected.score} p={p} />
          </>
        ) : <span style={{ flex: 1, fontSize: 13, color: p.muted, padding: '6px 0' }}>Choose a vendor…</span>}
        <span style={{ color: p.faint, fontSize: 10 }}>▾</span>
      </button>
      {open && (
        <div style={{ position: 'absolute', top: 'calc(100% + 4px)', left: 0, right: 0, zIndex: 30, ...panel(p), boxShadow: '0 12px 32px rgba(15,23,42,.18)', overflow: 'hidden' }}>
          <div style={{ padding: 8, borderBottom: `1px solid ${p.line}` }}>
            <input autoFocus value={q} onChange={e => setQ(e.target.value)} placeholder="Search vendors" style={{
              width: '100%', boxSizing: 'border-box', padding: '7px 9px', fontSize: 12.5, borderRadius: 6, border: `1px solid ${p.line}`,
              background: p.surface2, color: p.ink, fontFamily: sans, outline: 'none',
            }} />
          </div>
          <div style={{ maxHeight: 300, overflowY: 'auto' }}>
            {shown.map(v => (
              <button key={v.id} type="button" onClick={() => { onChange(v.id); setOpen(false); setQ(''); }} style={{
                width: '100%', display: 'flex', alignItems: 'center', gap: 10, padding: '8px 10px', border: 'none', cursor: 'pointer', fontFamily: sans, textAlign: 'left',
                background: v.id === value ? p.accentBg : 'transparent', borderBottom: `1px solid ${p.line}`,
              }}>
                <VendorLogo name={v.name} domain={v.domain} size={26} isDark={isDark} />
                <span style={{ flex: 1, minWidth: 0 }}>
                  <span style={{ display: 'block', fontSize: 12.5, fontWeight: 600, color: p.ink, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    {v.name}{v.self && <span style={{ marginLeft: 6, fontSize: 9, fontWeight: 800, color: p.accent }}>YOUR COMPANY</span>}
                  </span>
                  <span style={{ display: 'block', fontSize: 10.5 }}>{freshness(v)}</span>
                </span>
                <ScoreChip score={v.score} p={p} />
              </button>
            ))}
            {!shown.length && <div style={{ padding: 16, fontSize: 12, color: p.muted, textAlign: 'center' }}>No vendors match.</div>}
          </div>
        </div>
      )}
    </div>
  );
}

/* ─── Page ─────────────────────────────────────────────────────────────────────────────────────── */
const REPORT_PREFIX: Record<TemplateId, string> = {
  board: 'BSR',
  'vendor-full': 'VRA', 'vendor-brief': 'EXB', portfolio: 'PRR', 'findings-csv': 'FND', 'register-csv': 'REG',
};
const NO_ROWS: any[] = [];

export default function Reports() {
  const { mode } = useCustomTheme();
  const isDark = mode === 'dark';
  const p = usePalette(isDark);
  const { user, tenant } = useAuth() as any;
  const { enqueueSnackbar } = useSnackbar();
  const width = useViewportWidth();
  const [params, setParams] = useSearchParams();

  const initialTemplate = (TEMPLATE_IDS as string[]).includes(params.get('template') || '') ? params.get('template') as TemplateId : 'vendor-full';
  const [templateId, setTemplateId] = useState<TemplateId>(initialTemplate);
  const [vendorId, setVendorId] = useState<string>(params.get('vendor') || '');
  const [classification, setClassification] = useState<Classification>('Confidential');
  const [preparedFor, setPreparedFor] = useState<string>('');
  const [vendorOpts, setVendorOpts] = useState<VendorReportOptions>(DEFAULT_VENDOR_OPTIONS);
  const [portfolioOpts, setPortfolioOpts] = useState<PortfolioReportOptions>(DEFAULT_PORTFOLIO_OPTIONS);
  const [boardOpts, setBoardOpts] = useState<BoardReportOptions>(DEFAULT_BOARD_OPTIONS);
  const [minSeverity, setMinSeverity] = useState<SeverityCut>('Low');
  const [reportId, setReportId] = useState(() => newReportId(REPORT_PREFIX[initialTemplate]));
  const [previewUrl, setPreviewUrl] = useState<string | null>(null);
  const [pageCount, setPageCount] = useState<number | null>(null);
  const [busy, setBusy] = useState(false);
  const [logo, setLogo] = useState<ReportLogo | null>(null);
  const template = TEMPLATES.find(t => t.id === templateId)!;

  // The PDF header carries the FluxWatch logo; downscale it once so every report stays small.
  useEffect(() => {
    const img = new Image();
    img.onload = () => {
      try {
        const w = Math.min(560, img.naturalWidth), h = Math.round(w * img.naturalHeight / img.naturalWidth);
        const canvas = document.createElement('canvas');
        canvas.width = w; canvas.height = h;
        canvas.getContext('2d')!.drawImage(img, 0, 0, w, h);
        setLogo({ data: canvas.toDataURL('image/png'), w, h });
      } catch { setLogo(null); }
    };
    img.src = '/logo.png';
  }, []);

  const companyName = tenant?.company_name || user?.company || 'Your organization';
  useEffect(() => { if (!preparedFor && companyName) setPreparedFor(companyName); }, [companyName]); // eslint-disable-line react-hooks/exhaustive-deps

  // Deep link: ?template=&vendor= so a configured report can be shared or bookmarked.
  useEffect(() => {
    const next = new URLSearchParams();
    next.set('template', templateId);
    if (template.scope === 'vendor' && vendorId) next.set('vendor', vendorId);
    if (next.toString() !== params.toString()) setParams(next, { replace: true });
  }, [templateId, vendorId]); // eslint-disable-line react-hooks/exhaustive-deps

  /* Data */
  const vendorsQuery = useQuery(vendorQueries.list());
  const myRisk = useQuery(myRiskQueries.status());
  const exportsQuery = useQuery(reportQueries.exports());
  const vendors = (vendorsQuery.data ?? NO_ROWS) as any[];

  const pickList: PickVendor[] = useMemo(() => {
    const list: PickVendor[] = vendors
      .map(v => ({ id: v.id, name: v.name, domain: v.domain, score: v.score ?? null, lastScan: v.lastScan || null }))
      .sort((a, b) => a.name.localeCompare(b.name));
    const self = myRisk.data?.profile;
    if (self) list.unshift({ id: self.vendor_id, name: self.name, domain: self.domain, score: self.score ?? null, lastScan: self.last_scan || null, self: true });
    return list;
  }, [vendors, myRisk.data]);

  useEffect(() => {
    if (!vendorId && pickList.length && vendorsQuery.isSuccess) {
      const firstScanned = pickList.find(v => !v.self && v.score != null) || pickList[0];
      setVendorId(firstScanned.id);
    }
  }, [pickList, vendorId, vendorsQuery.isSuccess]);

  const vendorReport = useQuery({ ...reportQueries.vendor(vendorId), enabled: template.scope === 'vendor' && !!vendorId });
  const portfolioReport = useQuery({ ...reportQueries.portfolio(), enabled: template.scope === 'portfolio' && templateId !== 'board' });
  const boardReport = useQuery({ ...reportQueries.board(), enabled: templateId === 'board' });
  const activeQuery = template.scope === 'vendor' ? vendorReport : templateId === 'board' ? boardReport : portfolioReport;
  const bData = boardReport.data as BoardReportData | undefined;
  const vData = vendorReport.data as VendorReportData | undefined;
  const pData = (templateId === 'board' ? boardReport.data : portfolioReport.data) as PortfolioReportData | undefined;

  useEffect(() => { setReportId(newReportId(REPORT_PREFIX[templateId])); }, [templateId, vendorId]);

  const meta: ReportMeta = useMemo(() => ({
    reportId, generatedAt: new Date(), preparedFor: preparedFor.trim() || companyName,
    preparedBy: user?.name || user?.email || 'FluxWatch', classification, logo,
  }), [reportId, preparedFor, companyName, user, classification, logo]);

  /* Build the document (also drives the live preview) */
  const buildPdf = () => {
    if (templateId === 'board') return bData ? buildBoardReport(bData, meta, boardOpts) : null;
    if (templateId === 'portfolio') return pData ? buildPortfolioReport(pData, meta, portfolioOpts) : null;
    if (templateId === 'vendor-full' || templateId === 'vendor-brief') {
      return vData ? buildVendorReport(vData, meta, { ...vendorOpts, variant: templateId === 'vendor-brief' ? 'summary' : 'detailed' }) : null;
    }
    return null;
  };
  const csv: CsvResult | null = useMemo(() => {
    if (templateId === 'findings-csv' && vData) return findingsCsv(vData, minSeverity);
    if (templateId === 'register-csv' && pData) return vendorRegisterCsv(pData);
    return null;
  }, [templateId, vData, pData, minSeverity]);

  useEffect(() => {
    if (template.format !== 'PDF') { setPreviewUrl(null); setPageCount(null); return; }
    let url: string | null = null;
    const timer = window.setTimeout(() => {
      try {
        const doc = buildPdf();
        if (!doc) { setPreviewUrl(null); setPageCount(null); return; }
        setPageCount(doc.getNumberOfPages());
        url = URL.createObjectURL(doc.output('blob'));
        setPreviewUrl(url);
      } catch (err) {
        console.error('Report preview failed', err);
        setPreviewUrl(null);
      }
    }, 250);
    return () => { window.clearTimeout(timer); if (url) URL.revokeObjectURL(url); };
  }, [templateId, vData, pData, bData, vendorOpts, portfolioOpts, boardOpts, meta]); // eslint-disable-line react-hooks/exhaustive-deps

  /* Export */
  const logExport = useMutation({
    mutationFn: (body: any) => api.post('/v1/reports/exports', body),
    meta: { invalidates: [['reports', 'exports']] },
  });

  const subjectName = template.scope === 'vendor' ? (vData?.vendor.name || pickList.find(v => v.id === vendorId)?.name || '') : (pData?.company_name || companyName);
  const fileBase = `${slug(subjectName)}-${slug(template.name)}-${new Date().toISOString().slice(0, 10)}`;

  const download = async () => {
    if (busy) return;
    setBusy(true);
    try {
      let pages: number | null = null;
      if (template.format === 'PDF') {
        const doc = buildPdf();
        if (!doc) throw new Error('Report data is not loaded yet');
        pages = doc.getNumberOfPages();
        doc.save(`${fileBase}.pdf`);
      } else {
        if (!csv) throw new Error('Report data is not loaded yet');
        downloadFile(csv.csv, `${fileBase}.csv`);
      }
      const options: Record<string, any> = { classification };
      if (templateId === 'vendor-full') Object.assign(options, vendorOpts);
      if (templateId === 'portfolio') Object.assign(options, portfolioOpts);
      if (templateId === 'board') Object.assign(options, boardOpts);
      if (templateId === 'findings-csv') options.minSeverity = minSeverity;
      logExport.mutate({
        template: templateId, title: `${template.name} - ${subjectName}`, format: template.format, scope: template.scope,
        vendor_id: template.scope === 'vendor' ? vendorId : null, pages: pages ?? csv?.rows.length ?? null, options,
      });
      enqueueSnackbar(`${template.name} downloaded`, { variant: 'success' });
      setReportId(newReportId(REPORT_PREFIX[templateId]));
    } catch (err: any) {
      enqueueSnackbar(err?.message || 'Could not generate the report', { variant: 'error' });
    } finally { setBusy(false); }
  };

  const openPreview = () => { if (previewUrl) window.open(previewUrl, '_blank', 'noopener'); };

  const rerun = (e: any) => {
    const t = (TEMPLATE_IDS as string[]).includes(e.template) ? e.template as TemplateId : null;
    if (!t) return;
    setTemplateId(t);
    if (e.vendor_id) setVendorId(e.vendor_id);
    const o = e.options || {};
    if (CLASSIFICATIONS.includes(o.classification)) setClassification(o.classification);
    if (t === 'vendor-full') setVendorOpts(v => ({ ...v, ...Object.fromEntries(VENDOR_TOGGLES.map(x => [x.key, o[x.key] ?? v[x.key]])) }));
    if (t === 'board') setBoardOpts(v => ({ ...v, ...Object.fromEntries(BOARD_TOGGLES.map(x => [x.key, o[x.key] ?? v[x.key]])) }));
    if (t === 'portfolio') setPortfolioOpts(v => ({ ...v, ...Object.fromEntries(PORTFOLIO_TOGGLES.map(x => [x.key, o[x.key] ?? v[x.key]])) }));
    if (t === 'findings-csv' && SEVERITY_CUTS.includes(o.minSeverity)) setMinSeverity(o.minSeverity);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  /* Portfolio snapshot (from the vendor list; no extra fetch) */
  const snapshot = useMemo(() => {
    const scored = vendors.filter(v => v.score != null);
    const avg = scored.length ? Math.round(scored.reduce((a, v) => a + v.score, 0) / scored.length) : null;
    const elevated = vendors.filter(v => ['high', 'critical'].includes((v.riskLevel || '').toLowerCase())).length;
    const stale = vendors.filter(v => (daysSince(v.lastScan) ?? 9999) > 30).length;
    const exportsMonth = (exportsQuery.data || []).filter((e: any) => (daysSince(e.created_at) ?? 99) <= 30).length;
    return { total: vendors.length, scored: scored.length, avg, elevated, stale, exportsMonth };
  }, [vendors, exportsQuery.data]);

  /* Readiness warnings for the chosen subject */
  const warnings: { tone: 'amber' | 'red' | 'muted'; text: string }[] = [];
  if (template.scope === 'vendor' && vData) {
    if (!vData.scan) warnings.push({ tone: 'red', text: 'This vendor has no completed scan yet, so the report will be empty. Run a scan first.' });
    else {
      const age = daysSince(vData.scan.completed_at) ?? 0;
      if (age > 30) warnings.push({ tone: 'amber', text: `The latest scan is ${age} days old. Consider rescanning before sharing this report.` });
    }
  }
  if (template.scope === 'portfolio' && pData) {
    const never = pData.vendors.filter(v => v.score == null).length;
    if (!pData.vendors.length) warnings.push({ tone: 'red', text: 'There are no vendors in your portfolio yet.' });
    else if (never) warnings.push({ tone: 'amber', text: `${never} vendor${never === 1 ? ' has' : 's have'} never been scanned and will show as not assessed.` });
  }

  /* Layout */
  const mid = width >= 980;
  const loadingData = activeQuery.isFetching && !activeQuery.data;
  const failed = activeQuery.isError;

  const tile = (label: string, value: React.ReactNode, sub: React.ReactNode) => (
    <div style={{ ...panel(p), padding: '12px 16px' }}>
      <div style={groupLabel(p)}>{label}</div>
      <div style={{ fontSize: 22, fontWeight: 800, color: p.ink, lineHeight: 1.1 }}>{value}</div>
      <div style={{ fontSize: 11.5, color: p.muted, marginTop: 4 }}>{sub}</div>
    </div>
  );

  const templateCols = width >= 1500 ? 3 : width >= 1100 ? 3 : width >= 760 ? 2 : 1;
  const templateList = (
    <div role="radiogroup" aria-label="Report template" style={{ display: 'grid', gridTemplateColumns: `repeat(${templateCols}, minmax(0, 1fr))`, gap: 12 }}>
      {TEMPLATES.map(t => {
        const on = t.id === templateId;
        const pdf = t.format === 'PDF';
        return (
          <button key={t.id} type="button" role="radio" aria-checked={on} onClick={() => setTemplateId(t.id)} style={{
            ...panel(p), textAlign: 'left', cursor: 'pointer', padding: 0, fontFamily: sans, display: 'flex', flexDirection: 'column',
            borderColor: on ? p.accent : p.line, boxShadow: on ? `0 0 0 1px ${p.accent}` : 'none', minWidth: 0,
            transition: 'border-color .12s, box-shadow .12s',
          }}>
            <div style={{ display: 'flex', alignItems: 'flex-start', gap: 12, padding: '14px 14px 10px' }}>
              <div style={{
                width: 38, height: 46, borderRadius: 6, flexShrink: 0, position: 'relative', border: `1px solid ${p.line}`,
                background: p.surface2, display: 'flex', alignItems: 'flex-end', justifyContent: 'center', paddingBottom: 6, boxSizing: 'border-box',
              }}>
                <span style={{ position: 'absolute', top: 8, left: 7, right: 7, height: 2, borderRadius: 1, background: p.lineStrong }} />
                <span style={{ position: 'absolute', top: 13, left: 7, right: 13, height: 2, borderRadius: 1, background: p.lineStrong }} />
                <span style={{
                  fontSize: 8.5, fontWeight: 800, letterSpacing: '.04em', padding: '1px 4px', borderRadius: 3,
                  color: pdf ? p.red : p.green, background: pdf ? p.redBg : p.greenBg,
                }}>{t.format}</span>
              </div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: '.07em', textTransform: 'uppercase', color: p.faint, marginBottom: 2 }}>{t.group}</div>
                <div style={{ fontSize: 13.5, fontWeight: 700, color: p.ink, lineHeight: 1.3 }}>{t.name}</div>
              </div>
              <span style={{
                width: 16, height: 16, borderRadius: '50%', flexShrink: 0, marginTop: 2, border: `1.5px solid ${on ? p.accent : p.lineStrong}`,
                display: 'flex', alignItems: 'center', justifyContent: 'center', boxSizing: 'border-box',
              }}>{on && <span style={{ width: 8, height: 8, borderRadius: '50%', background: p.accent }} />}</span>
            </div>
            <div style={{
              padding: '0 14px', fontSize: 12, color: p.muted, lineHeight: 1.5, flex: 1,
              display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden', minHeight: 36,
            } as React.CSSProperties}>{t.description}</div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 6, padding: '10px 14px 12px', marginTop: 10, borderTop: `1px solid ${p.line}`, flexWrap: 'nowrap', overflow: 'hidden' }}>
              {[t.audience, t.length, t.scope === 'vendor' ? 'One vendor' : 'All vendors'].map(x => (
                <span key={x} style={{ fontSize: 10.8, color: p.body, background: p.surface2, border: `1px solid ${p.line}`, borderRadius: 5, padding: '2px 7px', whiteSpace: 'nowrap' }}>{x}</span>
              ))}
            </div>
          </button>
        );
      })}
    </div>
  );

  const configure = (
    <div style={{ ...panel(p), alignSelf: 'start' }}>
      <div style={panelHead(p)}>
        <div>
          <div style={{ fontSize: 13.5, fontWeight: 700, color: p.ink }}>Configure</div>
          <div style={{ fontSize: 11.5, color: p.muted }}>{template.name}</div>
        </div>
        <FormatBadge format={template.format} p={p} />
      </div>
      <div style={{ padding: 16, display: 'flex', flexDirection: 'column', gap: 18 }}>
        <div>
          <div style={groupLabel(p)}>{template.scope === 'vendor' ? 'Vendor' : 'Scope'}</div>
          {template.scope === 'vendor' ? (
            pickList.length
              ? <VendorPicker vendors={pickList} value={vendorId} onChange={setVendorId} p={p} isDark={isDark} />
              : <div style={{ fontSize: 12.5, color: p.muted }}>{vendorsQuery.isPending ? 'Loading vendors…' : 'Add a vendor to generate this report.'}</div>
          ) : (
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '9px 11px', borderRadius: 8, border: `1px solid ${p.line}`, background: p.surface2 }}>
              <span style={{ fontSize: 13, fontWeight: 650, color: p.ink, flex: 1 }}>All vendors</span>
              <span style={{ fontSize: 12, color: p.muted }}>{snapshot.total} in portfolio</span>
            </div>
          )}
          {warnings.map((w, i) => (
            <div key={i} style={{
              marginTop: 8, fontSize: 11.8, lineHeight: 1.5, padding: '7px 10px', borderRadius: 7,
              color: w.tone === 'red' ? p.red : w.tone === 'amber' ? p.amber : p.muted,
              background: w.tone === 'red' ? p.redBg : w.tone === 'amber' ? p.amberBg : p.surface2,
            }}>{w.text}</div>
          ))}
        </div>

        {template.format === 'PDF' && (
          <div>
            <div style={groupLabel(p)}>Document</div>
            <div style={{ fontSize: 11.8, color: p.muted, marginBottom: 6 }}>Classification</div>
            <Segmented value={classification} onChange={setClassification} p={p} options={CLASSIFICATIONS.map(c => ({ v: c, label: c }))} />
            <div style={{ fontSize: 11.8, color: p.muted, margin: '12px 0 6px' }}>Prepared for</div>
            <input value={preparedFor} onChange={e => setPreparedFor(e.target.value.slice(0, 120))} placeholder={companyName} style={{
              width: '100%', boxSizing: 'border-box', padding: '8px 10px', fontSize: 12.5, borderRadius: 7, border: `1px solid ${p.line}`,
              background: p.surface, color: p.ink, fontFamily: sans, outline: 'none',
            }} />
          </div>
        )}

        {templateId === 'findings-csv' && (
          <div>
            <div style={groupLabel(p)}>Include findings</div>
            <Segmented value={minSeverity} onChange={setMinSeverity} p={p} options={[
              { v: 'Critical', label: 'Critical' }, { v: 'High', label: 'High+' }, { v: 'Medium', label: 'Medium+' }, { v: 'Low', label: 'All' },
            ]} />
          </div>
        )}

        {(templateId === 'vendor-full' || templateId === 'portfolio' || templateId === 'board') && (
          <div>
            <div style={groupLabel(p)}>Sections</div>
            <div style={{ border: `1px solid ${p.line}`, borderRadius: 8 }}>
              {((templateId === 'vendor-full' ? VENDOR_TOGGLES : templateId === 'board' ? BOARD_TOGGLES : PORTFOLIO_TOGGLES) as { key: string; label: string; hint: string }[]).map((tg, i, arr) => {
                const current: Record<string, any> = templateId === 'vendor-full' ? vendorOpts : templateId === 'board' ? boardOpts : portfolioOpts;
                const on = !!current[tg.key];
                const disabled = templateId === 'vendor-full' && tg.key === 'emptyCategories' && !vendorOpts.categories;
                const set = (v: boolean) => templateId === 'vendor-full'
                  ? setVendorOpts(o => ({ ...o, [tg.key]: v }))
                  : templateId === 'board'
                    ? setBoardOpts(o => ({ ...o, [tg.key]: v }))
                    : setPortfolioOpts(o => ({ ...o, [tg.key]: v }));
                return (
                  <div key={tg.key} style={{
                    display: 'flex', alignItems: 'center', gap: 10, padding: '9px 11px', opacity: disabled ? 0.45 : 1,
                    borderBottom: i < arr.length - 1 ? `1px solid ${p.line}` : 'none',
                  }}>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ fontSize: 12.5, fontWeight: 600, color: p.ink }}>{tg.label}</div>
                      <div style={{ fontSize: 11, color: p.faint }}>{tg.hint}</div>
                    </div>
                    <Switch on={on && !disabled} onChange={v => !disabled && set(v)} p={p} label={tg.label} />
                  </div>
                );
              })}
            </div>
          </div>
        )}

        {(templateId === 'vendor-brief' || template.format === 'CSV') && (
          <div>
            <div style={groupLabel(p)}>{template.format === 'CSV' ? 'Columns' : 'Contents'}</div>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
              {template.includes.map(x => (
                <span key={x} style={{ fontSize: 11.3, padding: '3px 8px', borderRadius: 6, border: `1px solid ${p.line}`, color: p.body }}>{x}</span>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );

  const ready = template.format === 'PDF' ? !!previewUrl : !!csv;
  const previewHeight = Math.max(560, (typeof window !== 'undefined' ? window.innerHeight : 900) - 230);

  const preview = (
    <div style={{ ...panel(p), display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
      <div style={panelHead(p)}>
        <div style={{ minWidth: 0 }}>
          <div style={{ fontSize: 13.5, fontWeight: 700, color: p.ink }}>Preview</div>
          <div style={{ fontSize: 11.5, color: p.muted, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
            {template.format === 'PDF'
              ? (pageCount ? `${pageCount} page${pageCount === 1 ? '' : 's'} · A4 · ${classification} · ${reportId}` : 'Building…')
              : (csv ? `${csv.rows.length} row${csv.rows.length === 1 ? '' : 's'} · ${csv.header.length} columns · UTF-8` : 'Building…')}
          </div>
        </div>
        <div style={{ display: 'flex', gap: 8, flexShrink: 0 }}>
          {template.format === 'PDF' && <button type="button" style={btn(p, false, !previewUrl)} disabled={!previewUrl} onClick={openPreview}>Open in new tab</button>}
          <button type="button" style={btn(p, true, !ready || busy)} disabled={!ready || busy} onClick={download}>
            {busy ? 'Preparing…' : `Download ${template.format}`}
          </button>
        </div>
      </div>
      <div style={{ background: isDark ? '#050505' : '#E9EDF3', minHeight: 420, height: template.format === 'PDF' ? previewHeight : 'auto', display: 'flex', alignItems: 'stretch', justifyContent: 'center' }}>
        {failed ? (
          <div style={{ alignSelf: 'center', fontSize: 13, color: p.red, padding: 24 }}>Could not load the report data. Try again in a moment.</div>
        ) : template.scope === 'vendor' && !vendorId ? (
          <div style={{ alignSelf: 'center', fontSize: 13, color: p.muted, padding: 24 }}>Choose a vendor to preview the report.</div>
        ) : loadingData || !ready ? (
          <div style={{ alignSelf: 'center', display: 'flex', alignItems: 'center', gap: 10, fontSize: 13, color: p.muted }}>
            <span style={{
              width: 14, height: 14, borderRadius: '50%', border: `2px solid ${p.lineStrong}`, borderTopColor: p.accent,
              animation: 'rptSpin .8s linear infinite', display: 'inline-block',
            }} />
            Building the report…
          </div>
        ) : template.format === 'PDF' ? (
          <iframe title="Report preview" src={`${previewUrl}#view=FitH&navpanes=0`} style={{ border: 'none', width: '100%', height: '100%', background: '#fff' }} />
        ) : csv && (
          <div style={{ width: '100%', overflow: 'auto', background: p.surface, maxHeight: previewHeight }}>
            <table style={{ borderCollapse: 'collapse', fontSize: 11.5, fontFamily: sans, minWidth: '100%' }}>
              <thead>
                <tr>{csv.header.map(h => (
                  <th key={h} style={{ position: 'sticky', top: 0, background: p.surface2, color: p.muted, fontSize: 10, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '.05em', textAlign: 'left', padding: '8px 10px', borderBottom: `1px solid ${p.line}`, whiteSpace: 'nowrap' }}>{h}</th>
                ))}</tr>
              </thead>
              <tbody>
                {csv.rows.slice(0, 40).map((r, i) => (
                  <tr key={i}>{r.map((c, j) => (
                    <td key={j} title={c} style={{ padding: '7px 10px', borderBottom: `1px solid ${p.line}`, color: j === 0 ? p.ink : p.body, fontWeight: j === 0 ? 650 : 400, whiteSpace: 'nowrap', maxWidth: 260, overflow: 'hidden', textOverflow: 'ellipsis' }}>{c || '—'}</td>
                  ))}</tr>
                ))}
              </tbody>
            </table>
            {csv.rows.length > 40 && <div style={{ padding: '10px 12px', fontSize: 11.5, color: p.muted }}>Showing 40 of {csv.rows.length} rows. The download contains all of them.</div>}
            {!csv.rows.length && <div style={{ padding: 24, fontSize: 12.5, color: p.muted, textAlign: 'center' }}>Nothing matches these settings.</div>}
          </div>
        )}
      </div>
    </div>
  );

  const exportsRows = exportsQuery.data || [];
  const history = (
    <div style={{ ...panel(p), marginTop: 20 }}>
      <div style={panelHead(p)}>
        <div>
          <div style={{ fontSize: 13.5, fontWeight: 700, color: p.ink }}>Recent exports</div>
          <div style={{ fontSize: 11.5, color: p.muted }}>Every report anyone on your team downloaded. Also recorded in the audit log.</div>
        </div>
      </div>
      {exportsQuery.isPending ? (
        <div style={{ padding: 20, fontSize: 12.5, color: p.muted }}>Loading…</div>
      ) : !exportsRows.length ? (
        <div style={{ padding: '28px 16px', textAlign: 'center' }}>
          <div style={{ fontSize: 13, fontWeight: 650, color: p.ink }}>No reports exported yet</div>
          <div style={{ fontSize: 12, color: p.muted, marginTop: 4 }}>Downloads appear here with who generated them and when.</div>
        </div>
      ) : (
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontFamily: sans }}>
            <thead>
              <tr>{['Report', 'Subject', 'Format', 'Size', 'Generated by', 'When', ''].map(h => (
                <th key={h} style={{ textAlign: 'left', fontSize: 10, fontWeight: 700, letterSpacing: '.06em', textTransform: 'uppercase', color: p.faint, padding: '9px 16px', borderBottom: `1px solid ${p.line}`, background: p.surface2, whiteSpace: 'nowrap' }}>{h}</th>
              ))}</tr>
            </thead>
            <tbody>
              {exportsRows.map((e: any) => {
                const t = TEMPLATES.find(x => x.id === e.template);
                const subject = e.scope === 'portfolio' ? 'All vendors' : (e.vendor_name || 'Deleted vendor');
                const size = e.pages == null ? '—' : t?.format === 'CSV' ? `${e.pages} rows` : `${e.pages} pages`;
                return (
                  <tr key={e.id}>
                    <td style={{ padding: '10px 16px', borderBottom: `1px solid ${p.line}`, fontSize: 12.5, fontWeight: 650, color: p.ink }}>{t?.name || e.template}</td>
                    <td style={{ padding: '10px 16px', borderBottom: `1px solid ${p.line}`, fontSize: 12.5, color: p.body }}>{subject}</td>
                    <td style={{ padding: '10px 16px', borderBottom: `1px solid ${p.line}` }}>{t && <FormatBadge format={t.format} p={p} />}</td>
                    <td style={{ padding: '10px 16px', borderBottom: `1px solid ${p.line}`, fontSize: 12, color: p.muted }}>{size}</td>
                    <td style={{ padding: '10px 16px', borderBottom: `1px solid ${p.line}`, fontSize: 12.5, color: p.body }}>{e.user_name || '—'}</td>
                    <td style={{ padding: '10px 16px', borderBottom: `1px solid ${p.line}`, fontSize: 12, color: p.muted, whiteSpace: 'nowrap' }} title={new Date(e.created_at).toLocaleString()}>
                      {fmtDate(e.created_at)} · {new Date(e.created_at).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                    </td>
                    <td style={{ padding: '10px 16px', borderBottom: `1px solid ${p.line}`, textAlign: 'right' }}>
                      {t && (e.scope === 'portfolio' || e.vendor_name) && (
                        <button type="button" onClick={() => rerun(e)} style={{ ...btn(p), padding: '5px 10px', fontSize: 11.5 }}>Generate again</button>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );

  return (
    <div style={{ fontFamily: sans, background: p.bg, minHeight: '100vh', padding: mid ? '22px 28px 48px' : '18px 16px 40px', boxSizing: 'border-box', width: '100%' }}>
      <style>{'@keyframes rptSpin { to { transform: rotate(360deg); } }'}</style>

      <div style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between', gap: 16, flexWrap: 'wrap', marginBottom: 18 }}>
        <div>
          <h1 style={{ margin: 0, fontSize: 24, fontWeight: 800, color: p.ink, letterSpacing: '-.01em' }}>Reports</h1>
          <div style={{ fontSize: 13, color: p.muted, marginTop: 4 }}>
            Board-ready PDFs and analysis-ready spreadsheets, built from your latest scans. Pick a template, tune it, check the live preview, download.
          </div>
        </div>
        <button type="button" style={btn(p)} onClick={() => { navigator.clipboard?.writeText(window.location.href); enqueueSnackbar('Link to this report setup copied', { variant: 'success' }); }}>
          Copy link
        </button>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: mid ? 'repeat(4, minmax(0, 1fr))' : 'repeat(2, minmax(0, 1fr))', gap: 12, marginBottom: 20 }}>
        {tile('Vendors in scope', snapshot.total, `${snapshot.scored} with a completed scan`)}
        {tile('Average score', snapshot.avg == null ? '—' : <span style={{ color: scoreTone(p, snapshot.avg).fg }}>{snapshot.avg}<span style={{ fontSize: 13, color: p.muted, fontWeight: 700 }}> / 100 · {gradeOf(snapshot.avg)}</span></span>, 'Across assessed vendors')}
        {tile('High & critical risk', <span style={{ color: snapshot.elevated ? p.red : p.ink }}>{snapshot.elevated}</span>, 'Vendors to escalate')}
        {tile('Stale assessments', <span style={{ color: snapshot.stale ? p.amber : p.ink }}>{snapshot.stale}</span>, `Older than 30 days · ${snapshot.exportsMonth} export${snapshot.exportsMonth === 1 ? '' : 's'} this month`)}
      </div>

      <div style={{ display: 'flex', alignItems: 'baseline', justifyContent: 'space-between', marginBottom: 10 }}>
        <div style={{ fontSize: 14, fontWeight: 700, color: p.ink }}>1. Choose a template</div>
        <div style={{ fontSize: 12, color: p.muted }}>{TEMPLATES.filter(t => t.format === 'PDF').length} PDF reports · {TEMPLATES.filter(t => t.format === 'CSV').length} spreadsheet exports</div>
      </div>
      {templateList}
      <div style={{ fontSize: 14, fontWeight: 700, color: p.ink, margin: '24px 0 10px' }}>2. Configure and download</div>
      <div style={{ display: 'grid', gridTemplateColumns: mid ? '360px minmax(0, 1fr)' : '1fr', gap: 16, alignItems: 'start' }}>
        <div style={{ position: mid ? 'sticky' : 'static', top: 84 }}>{configure}</div>
        {preview}
      </div>

      {history}
    </div>
  );
}
